let cursorFeatureActive = false;
const colorMap = {
  'Black Night': '#000000',
  Silver: '#C0C0C0',
  'Tri Fade Burst': '#3B3A30',
  'Candy Apple': '#FF0800',
  'Jewel Blue': '#0F52BA',
  White: '#FFFFFF',
  Black: '#000000',
  Blue: '#0000FF',
  'Vintage Sunburst': '#C09040',
  Red: '#FF0000',
  'Zebra Neck': '#E0CF9F',
  'Black Neck': '#000000',
  'Brown Sunburst': '#A52A2A',
  'Candy Apple Red': '#FF0800',
  'Midnight Wine': '#4B0082',
  'Arctic White': '#F0F8FF',
  'Lake Placid Blue': '#007FFF',
  Natural: '#D2B48C',
  Sunburst: '#FF8C00',
  'Blizzard Pearl': '#E5E4E2',
  '3 Tone Sunburst': '#8B4513',
  'Olympic White': '#F8F8FF',
  'Transparent Red': '#FF6347',
  'Pearl White': '#FDFD96',
  'Celeste Blue': '#B0C4DE',
  'Mint Green': '#98FF98',
  'Snow White': '#FFFAFA',
  '2 Tone Sunburst': '#8B4513',
  'White Blonde': '#F5F5DC',
  'Black Flat': '#000000',
  'Charcoal Black': '#36454F',
  Champagne: '#F7E7CE',
  'Olympic Pearl': '#F8F8FF',
  'Sunset Metallic': '#FF4500',
  'Honey Natural': '#D2B48C',
  'Cherry Red': '#D2042D',
  Zebra: '#F5F5F5',
  'White Pearl': '#F5F5DC',
  'Black Metallic': '#808080',
  'Butterscotch Blonde': '#D2B48C',
  '3-Color Sunburst': '#8B4513',
  'Race Red': '#D50000',
  '2-Color Sunburst': '#C04000',
  'Ice Blue Metallic': '#AFDBF5',
  'FSR Surf Green': '#00C5CD',
  'Black Cherry': '#4E0707',
  'See Thru Black': '#2B2B2B',
  'Blood Burst': '#65000B',
  'Open Pore Vintage Sunburst': '#8B4513',
  'Open Pore Natural': '#D3D3D3',
  'Gloss White': '#FFFFFF',
  'Gloss Black': '#000000',
  'Alpine White': '#EDEDED',
  Ebony: '#0A0A0A',
  Brown: '#A52A2A',
  'Metallic Black': '#2F3136',
  'Metallic Grey': '#7B7F84',
  'Aged Black': '#484848',
  'Aged White': '#F5F5DC',
  'Satin Black': '#2F4F4F',
  Pink: '#FFC0CB',
  'Walnut Satin': '#775E54',
  'Crimson Red Burst': '#990000',
  'Trans Black Burst': '#393939',
  'White Bronco': '#F8F8FF',
  'Maroon Bronco': '#800000',
  'Vintage Red': '#C80815',
  'Rich Blue': '#4169E1',
  Lavender: '#E6E6FA',
  Mahogany: '#C04000',
  Yellow: '#FFFF00',
  Orange: '#FFA500',
  'Aged Satin Black': '#A9A9A9',
  'Vintage White': '#F5F5DC',
  'Natural Satin': '#D3D3D3',
  'Aged 2-Tone Sunburst': '#8B4513',
  'Cherry Sunburst': '#FF4500',
  'Fiesta Red': '#FF5733',
  'Black With Black PickGaurd': '#000000',
  Beige: '#F5F5DC',
  Grey: '#808080',
  'Transparent Red Sunburst': '#FF4500',
  'Faded Grey Burst': '#A9A9A9',
  'Cherry Red Sunburst': '#D2042D',
  'Limited Edition Lake Placid Blue': '#7DA7D9',
  'Deep Violet Metallic': '#7F00FF',
  'Champagne Gold': '#D4AF37',
  'Crimson Red': '#990000',
  'Dark Metallic Blue': '#00008B',
  'Aged Multi-ply binding': '#D3BEB2',
  'Vampire Red Satin': '#720001',
  '3 Color Sunburst': '#8B4513',
  Amber: '#FFBF00',
  'Transparent Black': '#000000',
  'Transparent Blue': '#0000FF',
  'Moonlight Burst': '#3B3C36',
  'Trans Cherry Burst': '#8B0000',
  Purple: '#800080',
  Green: '#008000',
  'Transparent Blue Sunburst': '#1E90FF',
  'Metallic Bronze': '#8C7853',
  Clear: '#FFFFFF',
  'Special Edition Blue': '#4169E1',
  'See Thru Blue': '#4682B4',
  'Gun Metal Gray': '#8A8A8A',
  'Surf Green': '#40E0D0',
  'Natural with Hard Case': '#D2B48C',
  'Mahogany with Hard Case': '#C04000',
  'Black with Hard Case': '#000000',
  'Sunburst with Hard Case': '#FF8C00',
  'Metallic Blue': '#0000CD',
  'Natural Low Gloss': '#D3D3D3',
  'Rustic Brown Low Gloss': '#8B4513',
  'Black Rutile': '#2F4F4F',
  'Brownish Sphalerite': '#8B4513',
  'Royal Blue Sapphire': '#4169E1',
  'Bright Brown Rutile': '#8B4513',
  'Red Spinel': '#8B0000',
  'Almandite Garnet': '#800000',
  'Brown - Acoustic Guitars': '#8B4513',
  'Vintage Cream': '#FBE7B2',
  Teaburst: '#CD5C5C',
  'Transparent Grey Flat': '#A9A9A9',
  'Sienna Sunburst': '#A0522D',
  'Sonic Blue': '#0F52BA',
  'Antique Burst': '#8B4513',
  'Gloss Black With Silver Pin Stripes': '#000000',
  'Gloss Black With Gold Stripes': '#000000',
  'Walnut Satin - WSN': '#5C4033',
  'Gloss Black - BLK': '#000000',
  'Classic Black': '#000000',
  'Silver Burst': '#C0C0C0',
  Classic: '#D3D3D3',
  'Silver Jubilee': '#C0C0C0',
  'Metallic Red': '#FF0000',
  'Metallic Goldtop': '#D4AF37',
  'Black Satin': '#555555',
  'Trans Black': '#000000',
  Nickel: '#C0C0C0',
  'Worn Cherry': '#A0522D',
  'Worn Brown': '#8B4513',
  'Mahogany Burst': '#C04000',
  '2-Tone Sunburst': '#D2691E',
  'Dark Brown': '#654321',
  'Wood Grain': '#8B7E66',
  Whitte: '#FFFFFF',
  Cocoa: '#D2691E',
  Chrome: '#C0C0C0',
  'Pitch Black': '#000000',
  Rosewood: '#800000',
  'Candy Red': '#FF0800',
  'Sunburst - Rosewood Fingerboard': '#FF4500',
  'Orange and Green': '#FFA500',
  'Stereo Set - Black': '#000000',
  'Stereo Set - Nickel': '#B0C4DE',
  'Tobacco Sunburst Quilt': '#8B4513',
  'Vintage Cherry': '#A52A2A',
  'Dark Wood Streak': '#8B4513',
  'Sunburst Streak': '#FF4500',
  'Transparent Light Brown Flat': '#D2B48C',
  'Baltic Blue Metallic': '#4C516D',
  'Copper Metallic': '#B87333',
  'Red Desert': '#8B0000',
  'Black Ice': '#1C1C1C',
  'Candy Apple Mist': '#E2062C',
  'Charcoal Mist': '#36454F',
  'Red Stream': '#FF4500',
  'Galaxy Silver': '#C0C0C0',
  'Hairline Blue': '#4682B4',
  'Black High Gloss': '#000000',
  'Natural High Gloss': '#F5F5DC',
  'Tobacco Sunburst': '#8B4513',
  'Trampas Green': '#3B7A57',
  'Whale Blue': '#1F75FE',
  'Weathered Black': '#696969',
  'Honey Burst': '#FFC30B',
  'Wine Red': '#722F37',
  'Translucent Blue': '#1C39BB',
  'Blueberry Burst': '#4F86F7',
  'Blood Orange': '#D1001C',
  Greenburst: '#00A86B',
  'Tobacco Brown': '#5B3A29',
  'Olive Metallic': '#B5B35C',
  Ivory: '#FFFFF0',
  'Midnight Satin Black': '#2D2E2E',
  'Elephant Grey': '#8E8E8E',
  'Egyptian Gold Metallic': '#D4AF37',
  'Cherry Burst': '#D2042D',
  'Trans. Charcoal Grey Wash': '#4B4B4B',
  'Electric Blue': '#7DF9FF',
  'Matt Black': '#383838',
  'Brown Sunburst High Gloss': '#8B4513',
  'Dark Violin Sunburst High Gloss': '#8B0000',
  'Brushed Nickel': '#A9A9A9',
  'Bundle - Natural': '#D2B48C',
  'Bundle - Black': '#000000',
  'Bundle - Natural Satin': '#C2B280',
  'Heritage Cherry Sunburst': '#D2691E',
  'Black & Chrome': '#C0C0C0',
  'Black / Blue': '#000000',
  'Midnight Blue': '#191970',
  'Walnut Flat': '#776655',
  'All Mahogany': '#3B3B3B',
  'Natural Ash': '#E5E4E2',
  Blush: '#DE5D83',
  Petrol: '#343B5A',
  'Midnight Black': '#2C2C2C',
  'Concrete Grey': '#5F5F5F',
  'Tobacco Brown Sunburst': '#8B4513',
  'Open Pore Mahogany': '#4E342E',
  'Tobacco Burst': '#8B4513',
  Cherry: '#8B0000',
  'Champagne Gold Metallic': '#D4AF37',
  'Scarlet Red': '#FF2400',
  'Sugar White': '#F5F5F5',
  Whtite: '#FFFFFF',
  'Silver Stream': '#C0C0C0',
  'Torino Red': '#FF6347',
  'Vintage Blonde': '#F3E5AB',
  Walnut: '#5C3A21',
  'Contemporary Black': '#2C2C2C',
  'Dark Walnut': '#4B3621',
  'Honey Blonde': '#F0C482',
  'Tobbaco Sunburst': '#8B4513',
  'Matte Gray': '#6E7F80',
  'Natural Color': '#F5F5DC',
  'Black Color': '#000000',
  'Tobacco Sunburst Color': '#8B4513',
  'Black Anodized': '#1C1C1C',
  'Bright Blue': '#007FFF',
  'Neon Orange': '#FF4500',
  'Nightshade Lacqure': '#003366',
  'Honey Amber': '#E2A76F',
  'Black Smoke': '#3B3B3B',
  'Jet Black': '#0D0D0D',
  'Smokey Chrome': '#708090',
  'High Voltage Blue': '#0047AB',
  'Pure White': '#FFFFFF',
  'Mirror Chrome': '#C5C9C7',
  'Grindstone Sparkle': '#B1A3A6',
  'Black Cherry Glitter': '#4B3621',
  Burgundy: '#800020',
  'British Racing Green': '#004225',
  'White Ash': '#FAF9F6',
  'Rosewood Grain with Black Finish': '#3B2F2F',
  Silverburst: '#C0C0C0',
  'Mystic Black': '#1C1C1C',
  'Transparent Amber': '#DFAF2C',
  'Dark Sunburst': '#8B4513',
  'Satin Rosewood': '#B76E79',
  'Ebony Polish': '#555D50',
  'Natural OIl': '#7C6D61',
  'Cherry Sunburst Color': '#E25822',
  'Mahogany Oil': '#C04000',
  'Blackberry Sunburst': '#4D1A3C',
  'Ocean Fade Metallic': '#274E77',
  'Open Pore Sunburst': '#8B4513',
  'Open Pore Black': '#2C2C2C',
  'Open Pore Black Cherry': '#8B0000',
  'Open Pore Black - Left Handed': '#000000',
  'Satin Red': '#C41E3A',
  'Caribbean Green': '#00FFCC',
  '2 Tone Burst': '#D2691E',
  'Beam Red': '#FF2400',
  'Regal Brown Burst': '#8B4513',
  'Purple Doom Burst': '#800080',
  '3-Tone Sunburst': '#8B4513',
  BROWNBURST: '#8B4513',
  'Red Metallic': '#FF0000',
  'Orange Black': '#FF4500',
  'Cream Black': '#FFFDD0',
  'Silver Black': '#C0C0C0',
  'Classic Blue': '#0000FF',
  'Classic Yellow': '#FFD700',
  'Warm Grey': '#9E9E9E',
  Blueburst: '#3A5FCD',
  'Black Red': '#8B0000',
  'White Black': '#FFFFFF',
  'Platinum Metallic': '#E5E4E2',
  'Red Wine': '#722F37',
  'Steel Blue': '#4682B4',
  'Walnut Stain': '#8B5A2B',
  'Satin Metallic Light Blue': '#8F9BA6',
  'Satin White': '#F5F5F5',
  'Wild Cherry Transparent': '#A91101',
  'Dusty Night': '#4E5A65',
  'Cosmic Black Burst': '#1C1C1C',
  'Honey Burst Satin': '#EDC9AF',
  'Transparent Blue Satin': '#6A5ACD',
  'Trans Red Satin': '#B22222',
  'Amber Sunburst': '#FFBF00',
  'Desert Haze': '#E3A857',
  'Silver Sterling': '#C0C0C0',
  'Trans Red': '#B22222',
  'Trans Amber': '#FFBF00',
  Violet: '#8A2BE2',
  Indigo: '#4B0082',
  'Cosmic Blackburst': '#1B1B1B',
  'Indigo Sparkle': '#4B0082',
  'Brushed Charcoal Black': '#36454F',
  'Midnight Gold Sparkle': '#FFD700',
  'Classic Green': '#00A550',
  'Crystal Sparkle': '#E6E8FA',
  'Transparent Dark Blue': '#003366',
  'Wine Red Sunburst': '#722F37',
  'Medium Cherry': '#C04000',
  'Gunsmoke Blue': '#4863A0',
  NCM: '#C0C0C0',
  NTM: '#D3D3D3',
  'Tone Burst': '#8A3324',
  'Matte Black': '#000000',
  'Faded Tortoise': '#79443B',
  'Antique White': '#FAEBD7',
  Cream: '#FFFDD0',
  Gold: '#FFD700',
  'Blue Moto': '#0000FF',
  Abalone: '#8A9A5B',
  'Red Moto': '#B22222',
  'Ocean Turquoise': '#3B7A99',
  'Black Moto': '#000000',
  'Translucent Black': '#1B1B1B',
  'Ruby Red Burst': '#9B111E',
  'Trans Green Burst': '#3B7A5D',
  'Pacific Blue Burst': '#1E3F66',
  'Vintage Burst': '#C09060',
  'Mystic Dream': '#4A6F70',
  'Translucent Purple Burst': '#5D3B6C',
  'Panther Black Night': '#1C1C1C',
  'Blue Metal Chameleon': '#1E3F66',
  'Green Yellow Chameleon': '#A7C957',
  'Mystic Green': '#35654D',
  'Pearl Red Burst': '#9B111E',
  'Sterling Silver': '#C0C0C0',
  'Stealth Black': '#0A0A0A',
  'Black Night With Fender Frontman 10G': '#0A0A0A',
  'Black Night With Laney LX10': '#0A0A0A',
  'Wine Red Burst': '#722F37',
  'Flat Black': '#000000',
  'Starlight Blue Sunburst': '#3A5E8C',
  'Pastel Pink': '#FFD1DC',
  'Sky Blue': '#87CEEB',
  'Vintage Tobacco Burst': '#8B4513',
  'Golden Bronze Glitter': '#D4AF37',
  'Lava Bubinga': '#8B3E2F',
  'Antique Brownburst': '#8B4513',
  'Dark Mocha Fade': '#4A3C31',
  'Satin Cherry Burst': '#9E1B32',
  'Vivid Red': '#FF2400',
  'Brown Burst': '#8B4513',
  'Transparent Grey Burst': '#696969',
  'Transparent Red Burst': '#FF4500',
  'British Green': '#355E3B',
  'Red Chameleon Sparkle': '#B22222',
  'Titanium Silver Metallic': '#B0B0B0',
  Rainbow: '#DDA0DD',
  'Black Wood Tone Finish': '#2F4F4F',
  'Oak Tone Finish': '#C3B091',
  'Nutmeg Burled Maple': '#8B4513',
  'Red Burst': '#B22222',
  'Emerald Burst': '#50C878',
  'Vintage Blue Metallic': '#5D8AA8',
  'Silver with Black Ring': '#C0C0C0',
  'Silver with Blue Ring': '#C0C0C0',
  'Simulated Rosewood': '#8B4513',
  'Black Sparkle': '#2F4F4F',
  'Blue Sparkle': '#4682B4',
  'Red Sparkle': '#FF6347',
  'Semi Gloss': '#C0C0C0',
  'Pearl White Metallic': '#F0EAD6',
  'Daphne Blue': '#3E9FDD',
  'Open Pore': '#8B7D6B',
  'Ruby Red': '#9B111E',
  'WL50BX Black': '#000000',
  'WL50T Tan': '#D2B48C',
  'Natural Wood': '#DEB887',
  'Dark Wood': '#8B4513',
  'Ghost Silver': '#C0C0C0',
  'Controller with Headphone': '#808080',
  'Dj Controller': '#000000',
  'Carbon Fiber Pattern': '#3B3B3B',
  'Vintage Burgundy Sparkle': '#800020',
  'Blue Chameleon Sparkle': '#3A5FCD',
  'Chocolate Brown Sunburst': '#8B4513',
  'Transparent Black Sunburst': '#2F4F4F',
  'Walnut Sunburst': '#5C4033',
  'See Thru Blue Burst': '#4682B4',
  'Flamed Maple': '#E5E4E2',
  'White Pearl Chrome': '#F5F5F5',
  'Neptune Blue': '#4F42B5',
  'Wild Cherry': '#D2042D',
  'Aged Whiskey Burst': '#D2B48C',
  'Sapphire Blue': '#0F52BA',
  'Dark Blue': '#00008B',
  'Charcoal Brown Burst': '#5B3A29',
  'Natural Gray Burst': '#A9A9A9',
  'Glow-in-the-Dark': '#00FF00',
  'Natural Browned Burst': '#8B4513',
  'Bright Orange Sparkle': '#FF4500',
  'Navy Blue': '#000080',
  'Space Gray': '#708090',
  'Green Burst': '#6F8F2F',
  'Green Apple Burst': '#8DB600',
  'Light Blue Burst': '#ADD8E6',
  'Pink Burst': '#FF69B4',
  'Yellow Burst': '#FFFF00',
  'Purple Burst': '#800080',
  'Orange Burst': '#FF4500',
  'Charcoal Black Sparkle': '#36454F',
  'Red Sea': '#8B0000',
  'Great White': '#F5F5F5',
  'Mako Blue': '#4682B4',
  'Yellow Coral': '#FFD700',
  'Sea Urchin Purple': '#5D3954',
  'Shell Pink': '#FFB6C1',
  'Shark Fin Gray': '#778899',
  'Seafoam Green': '#93E9BE',
  'Soft Pink': '#FDBCB4',
  'Tomato Red': '#FF6347',
  'Slate Blue': '#6A5ACD',
  'Pale Yellow': '#FAFAD2',
  'Light Grey': '#D3D3D3',
  'Silver Sparkle': '#C0C0C0',
  'California Blue': '#A2CAF2',
  'Nextel Grey': '#4F5055',
  Gray: '#808080',
  Ash: '#B2BEB5',
  'Black Edition': '#000000',
  'Grey Black': '#51585E',
  'Blue Metallic': '#32527B',
  Slate: '#708090',
  'Transparent Blue Burst': '#3C69E7',
  'Deep Black': '#000000',
  'Ebony Blue': '#23395D',
  'Iron Grey': '#7C7C7C',
  'Stryker Red': '#FF2400',
  'Savannah Sunset': '#FFCC99',
  Creme: '#FFFDD0',
  Turquoise: '#40E0D0',
  'Vintage Natural': '#D3B599',
  'Charcoal Transparent': '#36454F',
  'Silver Metallic': '#C0C0C0',
  'Charcoal Metallic': '#4A4A4A',
  'Vintage Brown Sunburst High Gloss': '#8B4513',
  'Galaxy Black Open Pore': '#1C1C1C',
  'Santana Yellow': '#FFD700',
  'Black Gold Burst': '#B8860B',
  Platinum: '#E5E4E2',
  'Sapphire Blue Flat': '#0F52BA',
  'Caribbean Shoreline Flat': '#00CED1',
  'Transparent Gray Flat': '#A9A9A9',
  'White Frost Flat': '#F8F8FF',
  'Dragon Eye Burst': '#DA3287',
  'Worn Brown Satin': '#8B4513',
  'Satin Fireburst': '#B22222',
  'Heritage Sunburst': '#CDA434',
  CAMO: '#4B5320',
  'Satin Cherry': '#DE3163',
  'Satin Vintage Sunburst': '#C08081',
  'Tobacco Sunburst - Maple Neck': '#5C3317',
  'Bright Metallic Red': '#C41E3A',
  'Bright Metalic Red': '#C41E3A',
  'Dark Blue Metallic': '#1B3F8B',
  'Old Sunburst': '#E97451',
  'See Through Red': '#B22222',
  'Black Ice Burst': '#3A3B3C',
  'Blazing Dusk': '#4B0082',
  'Pelham Blue': '#4682B4',
  Fireburst: '#E25822',
  'Camo White': '#F5F5F5',
  S7G: '#000000',
  Wild: '#FFD700',
  Wood: '#DEB887',
  'Multi-Color': '#000000',
  Tiger: '#D2691E',
  Leopard: '#FF4500',
  'Red Bandana': '#FF0000',
  'Black Bandana': '#000000',
  'Kiesel Black': '#000000',
  'Gem Purple': '#8A2BE2',
  Maple: '#F5DEB3',
  'Camo Green & Brown': '#3B5323',
  'Olympic Pearl White': '#FAF0E6',
  'Iced Tea': '#883C0D',
  Honeyburst: '#F0C377',
  'Gold Top': '#D4AF37',
  'Pelham Blue Metalli Top': '#4682B4',
  'Honeyburst Perimeter Candy': '#F0C377',
  'Heritage Cherry Sunburst Candy': '#B22222',
  'Trans Amber Cherry Back Candy': '#FFA500',
  'Tobacco Sunburst Candy': '#8B4513',
  'Wine Red Candy': '#722F37',
  'Navy Brown': '#5B3A29',
  'Desert Burst': '#8B4513',
  'Translucent Ebony': '#555555',
  'Heritage Cherry': '#9C1C1C',
  'Satin Gold Top with Dark Black': '#D4AF37',
  'Satin Vintage Burst': '#CD853F',
  Copper: '#B87333',
  Honey: '#EC9F5A',
  'Misty Violet': '#9678B6',
  'See Thru Red': '#C30B4E',
  '3 Tone Burst': '#8A3324',
  'Contemporary Rosewood': '#674C47',
  'Shadow Greenburst': '#556B2F',
  'Shadow White': '#F8F8FF',
  'Light Orange': '#FFA500',
  'Trans Red Burst': '#B22222',
  'Ocean Blue': '#0077BE',
  'Satin Cobalt Blue': '#0047AB',
  'Satin Orange BLZ': '#FF4500',
  'Trans Blue Burst': '#1E90FF',
  'Gold Burst': '#FFD700',
  'Manhattan Midnight': '#191970',
  'Deep Cherry Burst': '#8B0000',
  'Walnut Glaze': '#4B3621',
  'Violet Oil': '#8A2BE2',
  'Flame Cherry Sunburst': '#FF4500',
  'Trans Blue': '#4682B4',
  'Alpine Gold': '#FFD700',
  'Ebony Gold': '#2C2C2C',
  'Wine Red Gold': '#722F37',
  'Creamy Pearl': '#F5F5DC',
  'Trans Orange': '#FF4500',
  'Guards Red': '#B22222',
  'Light Blue': '#ADD8E6',
  'Catalina Green': '#00BFFF',
  Aqua: '#00FFFF',
  'Orange Metallic': '#FF8C00',
  Fireglo: '#FF4500',
  Jetglo: '#000000',
  Mapleglo: '#D2B48C',
  'Baby Blue': '#89CFF0',
  'Bass White': '#F8F8FF',
  'White Pearl Black': '#FDF5E6',
  'Nirvana Black Satin': '#0C0C0C',
  'Ocean Blue Satin': '#4682B4',
  'Tobacco Satin': '#D2B48C',
  'Narvik Blue': '#1B3F8B',
  'Yellow Natural Satin': '#F4C430',
  'Neon Pink': '#FF6EC7',
  'Neon Yellow': '#EFD807',
  'Rocket Red': '#FF0000',
  'Slime Green': '#32CD32',
  'Transparent Purple Burst': '#9A32CD',
  'Mardi Gras Purple': '#8B008B',
  'Cataline Blue': '#007BA7',
  'Baby Come Back Blue': '#678C92',
  'Go go blue': '#0073CF',
  Blackburst: '#2E2E2E',
  'Copper Burst': '#B87333',
  'Vintage Tobacco Sunburst': '#C58B40',
  'Billet Green': '#006A4E',
  'Shop Black': '#0B0B0B',
  'Violin Sunburst': '#8B5A2B',
  'Light Amber Burst': '#FFBF00',
  'Root Beer': '#4C2F27',
  'Old Violin Sunburst': '#C87C5E',
  'Raspberry Red': '#E30B5D',
  'Black Steel': '#1C1C1C',
  'Red Copper': '#BC412B',
  'Stock Yellow': '#F5C71A',
  Cherryburst: '#D2691E',
  'Satin Ebony': '#555555',
  'Natural Clear': '#F5F5DC',
  'Natural Tint': '#D3D3D3',
  'Red Crackle': '#B22222',
  'White Crackle': '#FFFFFF',
  'Nirvana Black Stain High Polish': '#2F4F4F',
  'Burgundy Blackburst Stain High Polish': '#800020',
  'Gothic Black': '#0B0B0B',
  'Burgundy Stain High Polish': '#800020',
  'Vintage Sunburst High Polish': '#C68E17',
  'Black burst': '#000000',
  'Factory Blue': '#4682B4',
  'Fired Red': '#FF4500',
  'Shadows White': '#F8F8FF',
  'Faded Whale Blue': '#5F9EA0',
  'Teal Black': '#008080',
  'Cherry High Gloss': '#A02422',
  'Birds Natural': '#D2B48C',
  'Flame Natural': '#E1C699',
  'Gun Hill Blue': '#003366',
  'Boulevard Black': '#000000',
  'Antique Tobacco': '#8B4513',
  'Violin Amber': '#D4A017',
  'Saloon Burst': '#8B4513',
  'Shadow Black': '#1C1C1C',
  'Charcoal Burst': '#36454F',
  'Gray Black': '#A9A9A9',
  Jade: '#00A36C',
  Obsidian: '#3C3B3D',
  'Red Tiger': '#D2042D',
  'White High Gloss': '#FFFFFF',
  'Black Amber': '#4B3621',
  'Black Cherry Flame High Gloss': '#800000',
  'High Gloss Charcoal Flame': '#36454F',
  'Black Cherry Flame': '#800000',
  'Paradise Amber Flame': '#FFCC00',
  'Rusty Rat': '#B7410E',
  'Steel Rust': '#8A3324',
  'Bloody Mary': '#B22222',
  'Shady Mary': '#8B0000',
  'Snow Mary': '#FFFAFA',
  'Marine Mary': '#3B9C9C',
  'Specific Ocean': '#4682B4',
  'Gamera Black': '#0C0C0C',
  'Satin Dark Earth Burst': '#8B4513',
  'Satin Gold Burst': '#FFD700',
  'Ash Grey': '#B2BEB5',
  'Wall Fade': '#D3D3D3',
  'Holcomb Burst': '#1E3F66',
  'Holcomb Blue Burst': '#1F4F82',
  'Cleopatra Luthiers Oil Rubbed': '#DEB887',
  'El Toro Luthiers Oil Rubbed': '#8B0000',
  'Baby Blue High Polish': '#89CFF0',
  'Cream White High Polish': '#F5F5DC',
  'Charcoal Contour Burst': '#36454F',
  'Charcoal Satin Nitro': '#36454F',
  'McCarty Tobacco Sunburst Satin': '#C9A676',
  'Antique White Satin': '#FAEBD7',
  'Vintage Cherry Satin': '#A52A2A',
  Aquamarine: '#7FFFD4',
  'Mash Green': '#6E7F4F',
  'Black High Polish': '#000000',
  'Cherry Sunburst High Polish': '#E25822',
  'Tobacco Sunburst High Gloss': '#8B4513',
  'Shady Jane': '#8B4513',
  'Snow Jane': '#FFFFFF',
  'Cigar Factory': '#8B4513',
  'Punch Grand Puro': '#8B4513',
  'Burnt Almond': '#8B5A2B',
  'Burnt Maple Leaf': '#8B4513',
  'Crystal Satin Cherryburst': '#8B4513',
  'Crystal Satin Sweet Tea': '#D2B48C',
  'Blue Fade': '#5F9EA0',
  'Dark Cherry Sunburst': '#8B0000',
  'Artic White': '#F0F8FF',
  'Ice Tea': '#D2B48C',
  'Crystal Satin Walnut': '#8B5B4D',
  'Vintage Orange': '#D2691E',
  'Bengal Burst': '#FF8C00',
  'Aged Cherry Burst': '#B22222',
  'Distressed Tobacco Sunburst': '#8B4513',
  'Distressed Cherry Sunburst': '#A52A2A',
  'Transparent Green Burst': '#008B8B',
  'Space Grey': '#708090',
  'Rose Gold': '#B76E79',
  'Satin Charcoal': '#36454F',
  'Satin Vintage Cherry': '#C04000',
  'Punch Elite': '#FF4500',
  Macanudo: '#8B4513',
  'Black With Silver Pin Stripes': '#2F4F4F',
  'Gloss White with Black Pinstripes': '#F5F5F5',
  'Glossy Black With Silver Stripes': '#000000',
  'Glossy Black With Gold Stripes': '#FFD700',
  'Distressed Laguna Blue': '#4682B4',
  'Sunset Sunburst': '#FF4500',
  'Lambo Orange': '#FFA500',
  'Natural Open Pore Matt': '#C7B89B',
  'Winered Burst': '#722F37',
  'Midnightblue Burst': '#003366',
  'Natural Polish': '#D0C5B1',
  'Violin Burst': '#8B3A3A',
  'Natural Matte': '#D3C5A7',
  'Oriental Blue Burst': '#4682B4',
  'Dark Sun Red': '#8B0000',
  Sandburst: '#C2B280',
  'Red Sunburst': '#A52A2A',
  'Marine Sunburst': '#3B7A57',
  'Sand Burst': '#C2B280',
  'Sunburst High Gloss': '#8B4513',
  'Natural Matt': '#D3C5A7',
  'Vintage Sunburst High Gloss': '#8B4513',
  'Antique Natural': '#E0D5C6',
  'Classic White': '#F8F8FF',
  'Dark Tinted': '#8B4513',
  'Black Matt': '#2F4F4F',
  'Sunburst Satin': '#8B4513',
  'Tiger Eye': '#B8860B',
  'Koa Burst': '#B87333',
  'New England Burst': '#3A3A3A',
  'Cherry Cherry Burst': '#DE3163',
  'Brown Sunburst Gloss': '#8B4513',
  'Natural Gloss': '#F5F5DC',
  'Sunburst Matte': '#C0C0C0',
  'Black Crazy': '#000000',
  'White Crazy': '#FFFFFF',
  'Antique Nutmeg Gloss': '#8B4513',
  'Lime Green': '#32CD32',
  'Black Gold': '#FFD700',
  'Gun Metal': '#2C3539',
  'Black Blue': '#000080',
  'Black Green': '#013220',
  'Natural/Amber Lacquer': '#FFD700',
  'Natural/Maroon Lacquered': '#800000',
  'Black with White Rims': '#000000',
  'White with Black Rims': '#FFFFFF',
  'Silver Plated': '#C0C0C0',
  'Clear Lacquered': '#EDE7D9',
  'Natural/Blonde': '#D2B48C',
  'Clear Lacquer': '#EDE7D9',
  Carbon: '#2B2B2B',
  'Red Lacquered': '#FF0000',
  '3-Tone Sunburst High Gloss': '#8B4513',
  'Gold Lacquered': '#FFD700',
  'Oak Matte': '#A39480',
  'Black Polished': '#000000',
  'Black Matte': '#2B2B2B',
  Brass: '#B5A642',
  'Rosewood Matte': '#8B4513',
  'Light Brown Matt': '#A0522D',
  'Light Brown Matte': '#A0522D',
  'Skulls and Catacomb': '#2F4F4F',
  'Dark Meadow': '#556B2F',
  'Black Flower': '#4B0082',
  'Walnut Matte': '#8B572A',
  'Mahogany Polished': '#C04000',
  'Ebony/Rosewood Matte': '#555D50',
  'Gold Lacquer': '#D4AF37',
  'Dark Red Powder Coated': '#8B0000',
  'Ocean Blue Powder Coated': '#0077BE',
  'Black Lacquered': '#000000',
  'Blue Lacquered': '#1F75FE',
  Lacquer: '#C4A484',
  'Siver High Gloss': '#C0C0C0',
  'Red Glossy': '#FF0000',
  'Carbon Design': '#333333',
  'Light green': '#90EE90',
  'Matte Varnished': '#8B8B7A',
  'Unlacquered Special Vintage': '#C3B091',
  'Natural Violin Varnish': '#C3B091',
  'Black Glossy': '#000000',
  'Walnut Polished': '#5C4033',
  'Cherry Matte': '#D2042D',
  'Red/Black': '#8B0000',
  'Grey/Black': '#808080',
  'Yellow/Black': '#FFD700',
  'White/Black': '#FFFFFF',
  'White Polished': '#FFFFFF',
  'Maple Matte': '#D3B88C',
  'White Matte': '#F5F5F5',
  'Walnut Dark Matte': '#5C4033',
  'Marine Blue': '#3B83BD',
  'Cobalt Blue': '#0047AB',
  'Mahogany Matte': '#C04000',
  'Dark Vintage': '#3B2F2F',
  'High Gloss Silver Plated with Gold': '#C0C0C0',
  'Yellow Brass': '#FFD700',
  'Light Blue and Dark Blue': '#ADD8E6',
  'Purple and Dark Blue': '#800080',
  'Yellow and Orange': '#FFA500',
  'Clear Laquered': '#E6E8FA',
  'Raw Polished': '#B87333',
  'Autumn Burst': '#8A3324',
  'Limited Deep Black': '#000000',
  Inverted: '#000000',
  'Orange Edition': '#FFA500',
  'Antique Sunburst': '#8B4513',
  Ultramarine: '#3F00FF',
  'Transparent Black Burst': '#2B2B2B',
  'Blue Galaxy': '#1B3F8B',
  'Blue and Blue': '#3F4E8B',
  'Creme White': '#FFFDD0',
  Nussbaum: '#7B3F00',
  'Brown Fade': '#A52A2A',
  'Green Fade': '#228B22',
  'Amber Fade': '#FFBF00',
  'Brown Sunburst Matte': '#8B4513',
  'Transparent Blue Matte': '#1E90FF',
  'Red Galaxy Sparkle': '#FF4500',
  'Turquoise Galaxy Sparkle': '#40E0D0',
  'Transparent Black-Green': '#006400',
  'Brilliant Black': '#0A0A0A',
  'Chocolate Burl': '#7B3F00',
  'Brown Sunburst Satin': '#8B4513',
  'Vintage Onyx': '#4A4A4A',
  'Dusk Sun Red': '#8B0000',
  'Cobalt Aqua': '#0047AB',
  'Emerald Mist': '#50C878',
  'Sheer Blue': '#8ABAD3',
  'Sequoia Red': '#9E1A1A',
  'White Marine Pearl': '#F0F0F0',
  'Ice Blue Oyster': '#A9C0D9',
  'Matte Mocha Swirl': '#6C4F3D',
  'Piano Black': '#000000',
  'Bronze Metallic': '#CD7F32',
  'Aqua Blue Glitter': '#00BFFF',
  'Garnet Fade': '#8B0000',
  'Royal Blue Metallic': '#4169E1',
  'Limited Edition - Silver': '#C0C0C0',
  'Classic PreSonus Blue': '#0A3D91',
  'White Noise': '#F5F5F5',
  Tan: '#D2B48C',
  'See Through Purple Sunburst': '#8A2BE2',
  'Dark Brown Sunburst': '#654321',
  'Lemon Drop': '#F6EABE',
  'Satin Chrome': '#D3D3D3',
  'Graphite Black': '#2F4F4F',
  'Sonic Gray': '#465362',
  'Satin Nickel': '#AFAFAF',
  'Quilted Translucent Black': '#1C1C1C',
  'Black with Red': '#280000',
  'Black with White': '#676767',
  'Black with Blue': '#000033',
  'UK-003 Blue': '#0000FF',
  BlackGlossy: '#000000',
  RedGlossy: '#FF0000',
  BlackMatte: '#1C1C1C',
  YellowGlossy: '#FFFF00',
  WhiteGlossy: '#FFFFFF',
  BlueGlossy: '#0000FF',
  'Vintage Matte Black': '#1C1C1C',
  'Fluorescent Blue Raspberry': '#00FFFF',
  'Fluorescent Sour Apple Green': '#7FFF00',
  'Fluorescent Orangesicle': '#FF4500',
  'Cherry Red Burst': '#A52A2A',
  'Royal Blue': '#4169E1',
  Trooper: '#5C4033',
  'Olive burst': '#808000',
  'Pewter Abalone': '#8A9A5B',
  'Ginger Burst': '#B06500',
  'Royal Blue Burst': '#4169E1',
  'Gloss Deep Red Burst': '#8B0000',
  'Satin Black Burst': '#555555',
  'Satin Brown Burst': '#8B4513',
  'White Satin Pearl': '#F8F8FF',
  'Classic Satin Amberburst': '#FFBF00',
  'Faded Glory': '#4A4A4A',
  'Kobalt Blue Fade': '#0059B3',
  'Rose Mirage': '#FFC0CB',
  'Deep Forest Burst': '#228B22',
  'Solid Yellow': '#FFFF00',
  'Nebula Green Burst': '#00FF7F',
  'Fullerton Red': '#FF0000',
  'Clear Orange - Maple Fingerboard': '#FF7F00',
  'Tobacco Sunburst - Maple Fingerboard': '#8B4513',
  'Butterscotch Blonde - Maple Fingerboard': '#D2B48C',
  'Red Burst - Rosewood Fingerboard': '#8B0000',
  'Natural Gloss - Maple Fingerboard': '#F5F5DC',
  'Tobacco Sunburst - Rosewood Fingerboard': '#8B4513',
  'Blonde - Rosewood Fingerboard': '#F3E5AB',
  'Surf Green - Rosewood Fingerboard': '#40E0D0',
  'Blue Burst - Maple Fingerboard': '#0073CF',
  'Lake Placid Blue - Rosewood Fingerboard': '#1E90FF',
  'Gloss Black - Maple Fingerboard': '#000000',
  'Cerulean Blue Burst': '#2A52BE',
  'Charcoal Black Burst': '#36454F',
  'Pearl Black Fade Metallic': '#4B0082',
  'Blueburst - Rosewood Fingerboard': '#1E90FF',
  'Honeyburst - Rosewood Fingerboard': '#DAA520',
  'Natural Gloss - Rosewood Fingerboard': '#F5F5DC',
  'Irish Ale': '#A52A2A',
  'Bordeaux Red Metallic': '#800000',
  'Black Haze': '#696969',
  'Blueburst - Maple Fingerboard': '#1E90FF',
  'Gloss Black - Rosewood Fingerboard': '#000000',
  'Sugar Skull': '#FF6347',
  Amberburst: '#FFBF00',
  'Blue Lagoon Burst Flat': '#4F97A3',
  'Dragon Eye Burst Flat': '#9E3B3A',
  'See Thru Black Cherry': '#5D3C3A',
  'Black Natural Burst': '#3B2B2B',
  'Blue Natural Fade': '#4A7FA7',
  'Seashore Metallic Burst': '#C5DBE6',
  'Charred Champagne Burst': '#D4B89F',
  'Iron Pewter': '#5A5A5A',
  'Sky Veil Matte': '#A2C3D0',
  'Cerulean Aura Burst': '#007BA7',
  'Midnight Gray Burst': '#1C1C1C',
  'Deep Ocean Metallic': '#003366',
  'Roadster Orange Metallic': '#FF4500',
  'Aged Amber': '#FFBF00',
  'Transparent Mustard': '#E1AD01',
  'Royal Plum Burst': '#6F2DA8',
  'Dark Red': '#8B0000',
  '3 Color Burst': '#6E4826',
  'Butterscotch Blonde - Left Handed': '#D6AE01',
  'Transparent Emerald Burst': '#50C878',
  'Antique Olive': '#808000',
  'Black Basketweave Vinyl': '#000000',
  'Open Pore Walnut': '#6B4423',
  'Dakota Red': '#CB4154',
  'Black and Silver': '#C0C0C0',
  'Grey Burst': '#A9A9A9',
  'Sunburst Brown': '#8B4513',
  'Sunburst Red': '#FF4500',
  'Natural Semi-Gloss': '#D3D3D3',
  'Almond Brown Wood': '#D2B48C',
  USA: '#B0C4DE',
  'Black M3': '#000000',
  'White M1': '#FFFFFF',
  'Tobacco Sunburst Gloss': '#8B4513',
  'Black Gloss': '#000000',
  'Tobacco Sunburst Matte': '#8B4513',
  'Wine Red Sunburst Matte': '#722F37',
  'Wine Red Sunburst Gloss': '#722F37',
  'Transparent Blue Burst Gloss': '#0000FF',
  'Ultra Marine': '#3B83BD',
  'Black Dawn': '#000000',
  'Night Sky Burst': '#343a40',
  'Desert Dune': '#D8BFD8',
  'Redwood Burst': '#8B0000',
  'Black/White': '#FFFFFF',
  'Navy/Royal Blue': '#000080',
  'Silver Grey/Racing Red': '#C0C0C0',
  'Misty Grey & Leather Brown': '#B0C4DE',
  'Steel Grey & Moon': '#B0C4DE',
  'Misty Grey/Leather Brown': '#B0C4DE',
  'Steel Grey/Moon': '#B0C4DE',
  'Black/Racing Red': '#FF0000',
  'Black/Silver Grey': '#C0C0C0',
  'Navy/Black': '#000080',
  'Natural Wood/Black': '#8B4513',
  'Vintage Sunburst/Black': '#8B4513',
  'Purple Haze': '#800080',
  'Bison/Desert': '#8B4513',
  'Cream Bronco': '#FFFDD0',
  'Arctic Blue': '#ADD8E6',
  'Coal Black': '#2B2B2B',
  'Classic Grey': '#BEBEBE',
  'Denim Blue': '#1E3A5F',
  'Dusk Grey': '#4D4D4D',
  'Double Black': '#0A0A0A',
  Ashwood: '#B2B2B2',
  'Carved Mango Wood': '#D49B6D',
  'NP-12 White w Stand & Bench': '#FFFFFF',
  'NP-12 Black w Stand & Bench': '#000000',
  'NP-12 Black': '#000000',
  'NP-12 White': '#FFFFFF',
  'Fire Red Burst': '#FF4500',
  'CL-12 Black': '#000000',
  'CL-12 Alaia Blonde Maple': '#D8B384',
  'CL-12 Alaia Red Mahogany': '#800000',
  'Blue Burst': '#0000FF',
  'Violet Burst': '#8A2BE2',
  'New Mexico Sparkle': '#FFD700',
  'Florida Sparkle': '#FFD700',
  'Alaska Sparkle': '#FFD700',
  'Idaho Sparkle': '#B0A8B9',
  'Vermont Sparkle': '#C3B9C5',
  'Minnersota Sparkle': '#B5A8BC',
  'Dragon Graphic': '#1F2A44',
  'Faeire Graphic': '#E0D5E4',
  'Open Pore Blackcherry Burst': '#4B2E29',
  'Open Pore Black Burst': '#343434',
  'Charcoal Frost Metallic': '#5A5A5A',
  'Titanium - Silver': '#BFC1C2',
  'Standard Silver': '#C0C0C0',
  'Surreal Black Burst Gloss': '#2F2F2F',
  'Blue Starburst': '#3B83BD',
  'Open Pore Jean Burst': '#3C528A',
  'Open Pore Trans Grey': '#666666',
  'Navy Metallic': '#3F4A6B',
  'Light Vintage Burst': '#D4A373',
  'Iron Oxide': '#734A12',
  'Metallic Ash': '#B2B2B2',
  'Transparent Gray Burst': '#5C5C5C',
  'Kona Blue': '#003366',
  'Blue Burst/Flamed Top': '#1E4D8B',
  'Brown Burst/Flamed Top': '#8B4513',
  'Grey Burst/Flamed Top': '#808080',
  'Flip Purple': '#800080',
  'Flip Blue': '#4682B4',
  'Moss Green': '#8A9A5B',
  'Deep Blue': '#00008B',
  'Openpore Black': '#000000',
  'Openpore Black Cherry': '#8B0000',
  'Openpore Walnut': '#5C4033',
  'Coral Blue Burst': '#5F9EA0',
  'Blood Red': '#8A0707',
  'Brushed Silver': '#C0C0C0',
  'Metallic Light Blue': '#ADD8E6',
  'Chocolate Brown': '#8B4513',
  'Beam Blue': '#1E90FF',
  'Metallic Light Green': '#90EE90',
  'Polar White': '#FFFFFF',
  'Sonic Red': '#FF4500',
  Tidepool: '#0E4D92',
  'Capri Orange': '#FF4500',
  Buttercream: '#F3D5B5',
  'Sage Green Metallic': '#9C9C9C',
  'Sea Foam Green': '#93E9BE',
  'Black Cherry Burst': '#4D0F28',
  'Ocean Blue Burst': '#0077BE',
  'Orange Capri': '#FF4500',
  'Transparent Sunburst': '#E97451',
  'Two-Tone Sunburst': '#FFCC99',
  'Champange Mist': '#F0E68C',
  'Hairline Black': '#000000',
  'Blacked Out Black': '#000000',
  'Red Satin': '#C40233',
  'Burgundy Walnut Wrap': '#800020',
  'White Birch Wrap': '#F5F5DC',
  'Camphor Wood Grain - IC': '#A39480',
  'Ebony Blue Grain': '#1E3A5F',
  'Charcoal Silver': '#36454F',
  'See Thru Black Satin': '#36454F',
  'Scorched Copper Sparkle': '#B87333',
  'Transparent Blue Sunburst High Gloss': '#1F4D92',
  'Vintage Sunburst Satin': '#755A3C',
  'Trans Blue Satin': '#4682B4',
  'Ruby Red Burst Satin': '#9B111E',
  Lime: '#32CD32',
  'Trans Walnut': '#3B2F2F',
  'Black with White Body Binding': '#000000',
  'White with Black Body Binding': '#FFFFFF',
  'White Sparkle': '#EDEDED',
  'Toluca Lake Blue': '#3B83BD',
  'Flash Pink': '#FF69B4',
  'Matt Black/Silver': '#2F4F4F',
  'White/Orange': '#FFA500',
  Chestnut: '#7B3F00',
  'Emerald Green': '#50C878',
  Charcoal: '#36454F',
  Bengal: '#FFD700',
  'Aqua Blue': '#00FFFF',
  'Black and Orange': '#FF4500',
  'Black and Green': '#00FF00',
  'Black and Purple': '#800080',
  'Glossy White': '#FFFFFF',
  'Electric Magenta': '#FF00FF',
  'Open Pore Raw Burst': '#8B4513',
  'Open Pore Cobalt Burst': '#0047AB',
  'Antique White Blonde': '#FAEBD7',
  'Black Open Pore': '#000000',
  'Burgundy Mist': '#800020',
  Graphite: '#2F4F4F',
  'Malta Blue': '#007FFF',
  'Purple Neon': '#8A2BE2',
  'Road Flare Red': '#FF4500',
  'Rustic Copper': '#B87333',
  'Blue Moon Burst': '#87CEEB',
  'Silver Wave Black': '#C0C0C0',
  'Jetty Black': '#0A0A0A',
  'Belmont Blue': '#4682B4',
  'Electric Jade': '#00FF00',
  'Lake Placid Blue - Tortoiseshell Pickguard': '#0000FF',
  'Nebula Green Burst With Vault Fury 15': '#00FF7F',
  'Transparent Red With Vault Fury 15': '#FF6347',
  'Transparent Blue With Vault Fury 15': '#4682B4',
  'Transparent Black With Vault Fury 15': '#696969',
  'Ghost White': '#F8F8FF',
  'Black Pearl': '#1E1E1E',
  '3 Tone Tea Burst': '#FFCC99',
  'Black Planet Matte': '#000000',
  Blonde: '#F0E68C',
  'Satin Faded Honeyburst': '#D2B48C',
  'Satin Gold Top': '#D4AF37',
  'Gold Trim': '#FFD700',
  'Vintage Worn Cherry': '#A52A2A',
  'Vintage Worn Ebony': '#555555',
  'Vintage Worn Heritage Cherry Sunburst': '#B22222',
  'Vintage Worn Vintage Sunburst': '#8B4513',
  'Vintage Worn Walnut': '#5C4033',
  'Tobacco Sunburst Perimeter': '#8B4513',
  SpecialEdition: '#FFD700',
  'Red Pearl': '#800000',
  'Turquoise Pearl': '#40E0D0',
  'Snow White Pearl': '#FFFAFA',
  'Arctic Dream': '#AFDCEC',
  'Ice Crimson Red': '#DC143C',
  'Siberian Sapphire': '#0F52BA',
  'Blood Orange Burst': '#FF4500',
  'Cobalt Burst': '#0047AB',
  'Mohave Burst': '#C19A6B',
  'Worn Bourbon': '#8B4513',
  'Nirvana Black': '#0A0A0A',
  'Honey Violin': '#F0E68C',
  'Antique Brown Burst': '#8B4513',
  'Laser Blue': '#00BFFF',
  'Black Oak Wrap': '#2E2E2E',
  'Vintage White Sparkle': '#F5F5DC',
  'Natural Zebrawood Wrap': '#D2B48C',
  'Burgundy Red Transparent Satin': '#800020',
  'Nirvana Black Transparent Satin': '#0A0A0A',
  'White Lacquer': '#FFFFFF',
  'Brown Lacquer': '#A52A2A',
  'Blue Sunburst': '#4682B4',
  'Ebony Black Polish': '#0A0A0A',
  'White Polish': '#FFFFFF',
  'Sunburst - Only Guitar': '#FF4500',
  Concert: '#8B4513',
  Tenor: '#D2B48C',
  Baritone: '#A0522D',
  'ShadowBurst Gloss': '#4A444B',
  'Aluminium Clear': '#E5E4E2',
  'Aluminium Black': '#0A0A0A',
  'Aluminium Blue': '#0000FF',
  'Aluminium Red': '#FF0000',
  'Aluminium Green': '#00FF00',
  'Aluminium Yellow': '#FFFF00',
  'Aluminium Purple': '#800080',
  'Gloss White Polish': '#FFFFFF',
  'Ultra Violet': '#8A2BE2',
  'Satin Surf Green': '#ADC9B7',
  'Western Brown': '#8B4513',
  'Natural Pack': '#D2B48C',
  'Sunburst Pack': '#FF4500',
  'Polished Ebony': '#555555',
  'Polished White': '#FFFFFF',
  'Ivory White': '#FFFFF0',
  'Chili Red': '#C21807',
  'Pure Oak': '#D2B48C',
  'Brown Walnut': '#8B4513',
  'Sunburst Gloss': '#8B4513',
  'Trans Buttermilk': '#F5DEB3',
  'Black Wood Tone': '#000000',
  'Oak Tone': '#D2B48C',
  'Satin Lake Placid Blue': '#7D93B0',
  'Sunburst Fade': '#8B4513',
  'Red Strata': '#D50000',
  'Black and Silver Sparkle': '#A6A6A6',
  'Grey Strata': '#BEBEBE',
  'Sunburst Lacquer': '#8B4513',
  'Frozen Ocean': '#4A6D7C',
  'Polar Lights': '#B0E0E6',
  'Black Knight': '#000000',
  'Aurora Burst': '#8A2BE2',
  'Aqua Burst': '#00FFFF',
  'Tri-fade Burst Flat': '#8B4513',
  'Pearl White Flat': '#F8F9FA',
  'Seafoam Blue Flat': '#9FE2BF',
  'Matte Vintage Maple': '#D3BC8D',
  Steel: '#B0C4DE',
  'Caribbean Lacebark Pine Fade': '#8FB996',
  'Gloss Lacebark Pine Fade': '#8FB996',
  'Gloss Java Lacebark Pine': '#8B4513',
  'Gloss Garnet Lacebark Pine': '#8B0000',
  'Garnet Burst Lacebark Pine': '#8B0000',
  'Java Burst Lacebark Pine': '#8B4513',
  'Sapphire Burst Lacebark Pine': '#0F52BA',
  'Gloss Sapphire Lacebark Pine': '#0F52BA',
  Aubergine: '#614051',
  'Dark Metallic Red': '#8B0000',
  'Olive Green': '#556B2F',
  Transparent: '#FFFFFF',
  'Clear Red': '#FF0000',
  'Clear Blue': '#0000FF',
  'Coffee Teak Wrap': '#4B3621',
  'Race Green': '#004225',
  'Slick Silver': '#C0C0C0',
  'Montego Black Metallic': '#0A0A0A',
  'Black Shade': '#000000',
  'Metallic Red With GA-10': '#C8102E',
  'Black with GA-10': '#000000',
  'Sunburst with GA-10': '#FF4500',
  'Metallic Blue with GA-10': '#4682B4',
  'White with GA-10': '#FFFFFF',
  'Mocha Burst': '#3D2618',
  'Candy Apply Red': '#FF0800',
  'Brown Mahogany': '#8B4513',
  'TV Fuzz Black': '#0A0A0A',
  'Black Aurora Burst Gloss': '#0A0A0A',
  'Hazy Rose Metallic': '#D36E70',
  Teal: '#008080',
  'Island Burst': '#3CB371',
  'Trans Black Satin': '#696969',
  'Luke Blue': '#4169E1',
  'Hazel Burst': '#8E775E',
  'Original Multi-Colored': '#D4AF37',
  'Black Dark': '#000000',
  'Purple Metallic': '#800080',
  'Open Pore Tabacco Burst': '#6D4C41',
  'Light Burst': '#F5E1A4',
  'Natural Glossy': '#F5F5F5',
  'Aged Natural': '#D2B48C',
  Mocha: '#3F2A1D',
  'Limited Edition White': '#FFFFFF',
  'Metallic Orange': '#FF4500',
  'Aleutian Blue': '#1E90FF',
  'Limited Black': '#000000',
  'Black.': '#000000',
  'Single Barrel Stain': '#8B4513',
  'Transparent Green': '#008000',
  'Transparent Pink': '#FF69B4',
  'Black w Stand': '#000000',
  'White w Stand': '#FFFFFF',
  'Aqua Silver Burst': '#00FFFF',
  'Titanium Quartz': '#B0B0B0',
  'Village Amber': '#E29A45',
  'Natural Pearl': '#F5E1D3',
  'See-Thru Black Pearl': '#1C1C1C',
  'Vintage Amber Burst Low Gloss': '#FFB366',
  'Violin Sunburst Low Gloss': '#8B4513',
  'Tea Sunburst': '#D2B48C',
  'Transparent Brown': '#8B4513',
  'Cream Marble Wrap': '#F5F5DC',
  Van: '#F5DEB3',
  Peace: '#FFD700',
  'Transparent Wine Red': '#722F37',
  'Hairline Black w/ Chrome Hardware': '#3D3D3D',
  'Transparent Purple': '#6A0DAD',
  Khakhi: '#C3B091',
  'Classic Sunburst': '#FBC02D',
  'Transparent Butterscotch': '#DDAA00',
  'Classical Sunburst': '#EE7600',
  'FLAME GRAPHIC': '#FF4500',
  'GREEN KINTE': '#556B2F',
  'BEIGE FIBERSKYN': '#F5F5DC',
  'Red Tweed': '#FF0000',
  'Gray Tweed': '#808080',
  'Tie Dye': '#FF69B4',
  'Atomic Green': '#39FF14',
  'Atomic Snow': '#FFFFFF',
  'Atomic Coral': '#FF6347',
  'Atomic Frost': '#D3D3D3',
  'Atomic Ink': '#00008B',
  'Atomic Orange': '#FFA500',
  'Trans White Satin': '#FFFFFF',
  'Trans Black Burst Satin': '#000000',
  'Sunburst Glossy': '#FF8C00',
  'Sunburst Blu Glossy': '#4682B4',
  'Blue Glossy': '#0000FF',
  'Himalayan Blue': '#4B9CD3',
  'Sunburst BluSatin': '#4682B4',
  'Ultra Burst': '#8B0000',
  'Texas Tea': '#483C32',
  'Bronze Satin': '#CD7F32',
  'GREEN SPARKLE': '#00FF00',
  'AGED BROOKLYN BURST': '#3B2F2F',
  'PHANTOM METALLIC': '#1C1C1C',
  Gunmetal: '#2a3439',
  'Forge Glow Maple': '#B87333',
  'Midnight Sapphire': '#003366',
  'CHERRY GLOSS': '#D2042D',
  Dragonwood: '#4A3F30',
  Driftwood: '#C2B280',
  Nightwood: '#1A1A1A',
  Bonewood: '#F5F5DC',
  GRASS: '#00FF00',
  LEMON: '#FFF700',
  OCEAN: '#0077BE',
  'Black/Red': '#8B0000',
  Sand: '#C2B280',
  'Electric Pink': '#FF33CC',
  'Translucent Cherry': '#990000',
  'Mahogany Satin': '#3C1414',
  'Gold Sparkle': '#D4AF37',
  'Black & Blue': '#000000',
  'White & Blue': '#FFFFFF',
  'Yellow & Black': '#FFD700',
  'Sunset Orange': '#FF4500',
  'Beach White': '#FFFFFF',
  'Satin Honeyburst': '#DAA520',
  'Satin Iced Tea': '#D2B48C',
  'Satin Tobacco Burst': '#8B4513',
  'Satin Cherry Sunburst': '#FF6347',
  'Translucent Oxblood': '#3C1414',
  'Blue & Yellow': '#0000FF',
  'Orange & Green': '#FFA500',
  Navy: '#000080',
  'Blue Version': '#0000FF',
  'Gold Version': '#FFD700',
  'Pink Version': '#FFC0CB',
  'Red Version': '#FF0000',
  'Silver Version': '#C0C0C0',
  'White Version': '#FFFFFF',
  'Light Caramel Burst': '#8B4513',
  'Sixties Cherry': '#A04A4A',
  'Smokehouse Burst': '#D2691E',
  'Tangerine Burst': '#FF6347',
  'Bourbon Burst': '#8B4513',
  Unburst: '#C19A6B',
  'Artic Camouflage': '#708090',
  'Plasma Red Burst': '#FF4500',
  'Graphite Top': '#2F4F4F',
  'Sparkling Burgundy Top': '#800020',
  'Faded Pelham Blue Top': '#6A7F8A',
  Burgandy: '#800020',
  'Satin Brown': '#8B4513',
  'Teal Blue': '#008080',
  'Weathered Black Open Pore': '#696969',
  Ultraburst: '#483C32',
  'Black Paisley': '#3B3B3B',
  'Dodgem Blue': '#5B92E5',
  'Golden Mesa': '#DAA520',
  'Choper Blue': '#4682B4',
  'Charcoal Frost': '#36454F',
  Magenta: '#FF00FF',
  Butterscotch: '#D4AF37',
  'Three-Tone Sunburst': '#8B4513',
  'Silver/Black': '#C0C0C0',
  'White/Red': '#FF0000',
  Olive: '#808000',
  'Lake Blue Metallic': '#5D8AA8',
  'Natural Swamp  Ash': '#DEB887',
  'Dark Scarlet Burst Satin': '#8A2F3D',
  'Pacific Blue Burst Satin': '#1CA9C9',
  'Iced Tea Burst': '#E6B800',
  'Trans Black Cherry Burst': '#8B0000',
  'Black With Blue Pearl Pickguard': '#000000',
  'Black with Maple Fingerboard': '#000000',
  'Black/Gold': '#FFD700',
  'Vintage Mahogany': '#C04000',
  'US Standard Chrome': '#B0C4DE',
  'US Standard Gold': '#FFD700',
  'Vintage Chrome': '#B0C4DE',
  'Fixed Chrome': '#B0C4DE',
  'Fixed Gold': '#FFD700',
  'Natural Swamp Ash': '#D3CEC4',
  'Maple Flame Black': '#2E2E2E',
  'Maple Flame Blue': '#0093AF',
  'Vincent Blue': '#0073CF',
  'Matt Natural': '#BC8F8F',
  'Matt Sunburst': '#E97451',
  'Arctic Pearl': '#FAFAFA',
  'Transparent Orange': '#FF4500',
  'Transparent Yellow': '#FFD300',
  Tweed: '#E3D7B6',
  'Brown Stripe': '#8B4513',
  'Maple Quilt Bengal Burst': '#FFB347',
  'Glossy Natural': '#D2B48C',
  'Glossy Sunburst': '#FF8C00',
  'Glossy Black': '#000000',
  Ruby: '#9B111E',
  'Satin Charcoal Burst': '#36454F',
  'Satin Sky Burst': '#87CEEB',
  'Cobra Blue': '#0047AB',
  'Purple Pearl': '#9C51B6',
  'Yellow Peral': '#F2C649',
  'Trans Teal': '#008080',
  'Gloss Natural': '#E5E5E5',
  'Gloss Sunburst': '#FF4500',
  'Gloss Wine Red': '#722F37',
  'Gloss Tobacco Sun Burst': '#8B4513',
  'Etched Black Gold': '#B8860B',
  'Etched Black Red': '#8B0000',
  'Glossy Sun Burst': '#FF6347',
  'Blue Crimson': '#123456',
  'Butterscotch Blonde- Medium Heavy': '#D7AF70',
  'Black- Extra Heavy': '#000000',
  'Daphne Blue- Thin': '#AEEEEE',
  'Surf Green- Thin Med': '#7FFFD4',
  'Olympic White- Medium': '#FFFFFF',
  'Fiesta Red- Heavy': '#FF4040',
  'Antique Amber': '#FFBF00',
  'Dark Blue Burst': '#00008B',
  'Crimson Red Transparent': '#DC143C',
  'Canary Diamond': '#FFEF00',
  'Firemist Gold': '#D4AF37',
  'Burgundy Mist Metallic': '#B76E79',
  'Neon Green': '#39FF14',
  'White Tweed': '#F5F5DC',
  'Honey Sunburst': '#E6A857',
  'Wild Honey Burst': '#E6A857',
  'Black Tweed': '#2B2B2B',
  'Riviera Blue': '#4169E1',
  'Fairlane Blue': '#1952A3',
  'Imperial Stain': '#8B4513',
  'Brownstone Maple': '#A0522D',
  'Pacific Blue': '#1CA9C9',
  'Borrego Red': '#BE0032',
  'Gaslamp Black': '#0A0A0A',
  Denim: '#1560BD',
  Golddust: '#D4AF37',
  'Western Sunburst': '#FFA500',
  'Blue Marble': '#3C69E7',
  'Green Marble': '#3CB371',
  'Orange Marble': '#FF8C00',
  'Desert Sand': '#EDC9AF',
  'Majestic Purple': '#6A0DAD',
  'Royal Red': '#9B111E',
  'Pacific Blue Burst Flat': '#1CA9C9',
  'Black Ice Flat': '#2A3439',
  Silvar: '#C0C0C0',
  'Pearl White Matte': '#F8F8FF',
  'Arctic Ocean Matte': '#A9D0F5',
  'Stained Wine Red Low Gloss': '#722F37',
  'Cosmic Blue Starburst Flat': '#0047AB',
  'Limited Edition Red': '#FF2400',
  'Black and Gray': '#4B4B4B',
  'Brown and Tan': '#8B4513',
  'Jet Black Metallic': '#0A0A0A',
  'Purple Passion Metallic': '#9C00FF',
  'Radio Blue Metallic': '#4169E1',
  'Smoked Almond Metallic': '#826644',
  'Scarlet Red Metallic': '#C21807',
  'Wanderlust Green Metallic': '#228B22',
  'Black Mirage Gradation': '#2C2C2C',
  'Inca Silver': '#B2BEB5',
  'Metallic Gold': '#D4AF37',
  'Sunset Yellow': '#FDB813',
  'Pewter Grey': '#8A8A8D',
  'Hot Pink': '#FF69B4',
  Koa: '#6E4C0A',
  Sitka: '#E8E3DB',
  'Worn Ebony': '#3B3B3B',
  'Worn Heritage Cherry Sunburst': '#C95A49',
  'Worn Metallic Gold': '#D4AF37',
  'Worn Purple': '#800080',
  'Aged Black Satin': '#3F3F3F',
  'Ebony Vintage Satin': '#555555',
  'Natural Walnut Satin': '#5C4033',
  'Faded Pelham Blue': '#769DA6',
  'Sparkling Burgundy': '#9F1D35',
  'Vintage Sparkling Burgundy': '#8B6F70',
  'Blue Stain': '#6A5ACD',
  'Walnut Burst': '#5C4033',
  'Satin Natural': '#E6D8B8',
  'Satin Walnut Burst': '#776655',
  'Trans Ebony': '#555555',
  'Woodgrain Black': '#444444',
  'Dark Blue Sparkle': '#1A1A7A',
  'Worn Inverness Green': '#556B2F',
  'Snow Edition White': '#FFFFFF',
  'Natural Walnut': '#A0522D',
  'Ruby Red Metallic': '#9B111E',
  'Sapphire Blue Metallic': '#0F52BA',
  'Emerald Green Metallic': '#50C878',
  'Topaz Gold Metallic': '#D4AF37',
  'Cherry MX Blue': '#003366',
  'Cherry MX Silver Speed': '#C0C0C0',
  Burst: '#8B0000',
  'Cherry MX Speed Silver': '#C0C0C0',
  'White with Black Bevels': '#FFFFFF',
  'Matte Army Drab': '#4B5320',
  'Satin Grey': '#BEBEBE',
  'Black With White Bevels': '#000000',
  'Black & Brass': '#D4AF37',
  'Brown Sunburst w Pedals': '#8B4513',
  'Black w Pedals': '#000000',
  'Arctic White W Pedals': '#F0F0F0',
  'Frozen Yellow': '#9FE2BF',
  'Ice Blue': '#AFDBF5',
  'Ebony Stain': '#555D50',
  'Ultra Violet Stain': '#8B00FF',
  'Cherry Stain': '#DE3163',
  'Antique Crimson Burst': '#AB4E52',
  'Black Mirror Chrome': '#000000',
  'Gloss Barnwood Brown': '#8B4513',
  'Nicotine White Marine': '#F5F5DC',
  'Scarlet Ash': '#FF2400',
  'Transparent Sonic Blue': '#87CEEB',
  'Cadillac Green': '#006400',
  'Azure Metallic': '#007FFF',
  Camouflage: '#78866B',
  'Natural Lacquer': '#D3D3D3',
  'Cherry Satin': '#D2042D',
  'Brown Gloss': '#8B4513',
  'Blazing Yellow': '#FFD700',
  'Teal Green': '#008080',
  'Raging Red': '#FF0000',
  'Rampant Red': '#FF0000',
  'Carbon Black': '#000000',
  'Black/Blue': '#00008B',
  'Grey/Green': '#708090',
  'Active Black': '#000000',
  'Jazzy Blue': '#0000CD',
  'Viper Green': '#32CD32',
  'Furious Blue': '#0000FF',
  'Cherry Stain Lacquer': '#DE3163',
  'Red To Black Fade': '#8B0000',
  'Pearlescent White': '#FFFFFF',
  Neon: '#39FF14',
  Enigma: '#8B008B',
  'Jungle Jam': '#228B22',
  Psyche: '#DA70D6',
  Prism: '#E5E4E2',
  Voyage: '#6F00FF',
  'Silver to Black Fade': '#C0C0C0',
  'Furious Red': '#D9001B',
  'Taffy Pink': '#FFC0CB',
  'Sunset Red': '#FF4500',
  'Moonlight Black': '#000000',
  'Regal Blue': '#002366',
  'Sapphire Green': '#0F9D58',
  'Skyline Blue': '#87CEEB',
  'Vivid Orange': '#FF6700',
  'Terracotta Brown': '#E2725B',
  'Salsa Red': '#F2003C',
  'Blooming Blue': '#1E90FF',
  'Tabacco Brown Sunburst': '#8B4513',
  'Army Green': '#4B5320',
  'Molten Orange': '#FF4500',
  Nickle: '#727472',
  'Neon Lime': '#32CD32',
  'Frosty White': '#F8F8FF',
  'Bordeaux Red': '#7B1B1B',
  'Spirit Lime': '#BFFF00',
  'Luscious Black': '#000000',
  'Hazel Beige': '#D2B48C',
  'Carmine Red': '#960018',
  'Buoyant Black': '#000000',
  'Fiery Red': '#FF0000',
  'Gregarious Green': '#00FF00',
  'Grey/Blue': '#708090',
  'Hot Red': '#FF4500',
  'Pop Yellow': '#FFD700',
  'Winter Grey': '#A9A9A9',
  'Twilight Blue': '#191970',
  'Titanium Black': '#0F0F0F',
  'Gold Beige': '#D4AF37',
  'Copper Black': '#5C4033',
  Mint: '#98FF98',
  Sienna: '#A0522D',
  'Light Pink': '#FFB6C1',
  'Faded Cherry': '#DC143C',
  'Candy Blue': '#1E90FF',
  'Icy White': '#F0F8FF',
  'Copper Blue': '#4682B4',
  'Charcoal Black Silicon Strap': '#2E2E2E',
  'Teal Green Silicon Strap': '#008080',
  'Racing Red Silicon Strap': '#FF0000',
  'Rose Beige': '#F4C2C2',
  'Stone Grey': '#708090',
  'Fluorescent Orange': '#FF4500',
  'Vampire Kiss': '#872657',
  'Camo Green': '#556B2F',
  'Vintage Brown': '#8B4513',
  'Metallic White': '#F5F5F5',
  'Mist Grey': '#C0C0C0',
  'Trans Gray': '#808080',
  'Mappa Burl': '#8B4513',
  'Lively Black': '#000000',
  'Brisk Blue': '#0E4C92',
  'Soft Black': '#2B2B2B',
  'Serene White': '#F5F5F5',
  'Calm Blue': '#5F9EA0',
  'Warm Beige': '#D9B99B',
  'Garnet Purple': '#673147',
  'Jade Green': '#00A86B',
  'Slate Black': '#2F2F2F',
  'Dusk Blue': '#4B6EAF',
  'Blush Pink': '#FFC0CB',
  'Translucent Red': '#FF2400',
  'Camphor Wood Grain': '#A67B5B',
  'Natural Poplar Burl Burst': '#BFAF8F',
  'Matt Honey': '#E5B73B',
  'Gloss Red': '#FF0000',
  'Mystic Surf Green': '#7FDBB6',
  'Matte Honey': '#E5B73B',
  'Matte Natural': '#D3BFA0',
  'Roasted Pine': '#B48756',
  'Dark Night': '#1A1A40',
  'Firestick Red': '#B22222',
  'Sweet Tea': '#D2B48C',
  'Sherwood Green': '#0B3C5D',
  'White/Blue': '#FFFFFF',
  'Graphite Metallic': '#53565A',
  'Faded Blue': '#5A79BA',
  'Bonnie Pink': '#FF69B4',
  'Charcoal Cherry Burst': '#36454F',
  'Neon/Prism': '#39FF14',
  'Peace Love Dove': '#D3D3D3',
  'Alpine Meadow': '#7CB342',
  'Premier Paisley': '#FFD700',
  'Tangerine Nightmist': '#FF4500',
  'Taos Fire Red': '#B22222',
  'Kaleidoscope Pink': '#FF69B4',
  'Midnight Blizzard': '#191970',
  'Pink Paisley': '#FFC0CB',
  'Redbird Rising': '#B22222',
  'Winter Rose': '#B22222',
  'Blackjack Red': '#8B0000',
  'Royal Flush Red': '#B22222',
  'Purple Bird Lupin': '#800080',
  'Paisley Dream': '#FFD700',
  'Kashmir Moonrise': '#708090',
  'Red Bird Winter': '#8B0000',
  'Red Trellis': '#A52A2A',
  'Midnight Paisley': '#191970',
  'Casino Couture': '#FF69B4',
  'Navy Blue and Beige Peace Love Dove': '#2F4F4F',
  'Spanish Rose': '#D10056',
  'Light Gray Blue': '#B0C4DE',
  'Yellow/Jungle Jam': '#FFD700',
  'Teal Green/Voyage': '#008080',
  'Eriza Verde': '#228B22',
  'Dark Honey Burst High Gloss': '#8B4513',
  'Indigo Blue Burst High Gloss': '#4B0082',
  'Bison Desert': '#A0522D',
  'Misty Grey Brown': '#708090',
  'Caribbean Blue Fade': '#00BFFF',
  'Caffe Latte Fade': '#D2B48C',
  'Magma Orange Fade': '#FF4500',
  'True Black': '#000000',
  'Mod White': '#FFFFFF',
  'Chill Gray': '#D3D3D3',
  Veneer: '#C7B299',
  'Etched Black': '#000000',
  'Etched Deep Violet': '#4B0082',
  'Red Black': '#8B0000',
  'Sunset Black': '#FF4500',
  'Gray Miami': '#A9A9A9',
  'Green Black': '#006400',
  'Soda Blue': '#87CEEB',
  'Laser Blue Matte': '#4169E1',
  'Champagne Sparkle': '#F7E7CE',
  'Moab Red Black': '#8B0000',
  'Tan Black': '#D2B48C',
  'Amber Open Pore': '#FFBF00',
  'Deep Forest Green Metallic': '#228B22',
  'Blue/Black': '#00008B',
  'Pure Mint': '#98FF98',
  'Electric Yellow': '#FFFF00',
  'Bleached Blue': '#B0E0E6',
  'Vice Gray Crimson': '#8B0000',
  'Grey Speckle Miami': '#A9A9A9',
  'Speckle Sunset Blue': '#4682B4',
  'Antique Brown Stained Low Gloss': '#8B4513',
  'Natural Flat': '#E5E4E2',
  'Cosmic Shadow': '#483D8B',
  'Cerulean Blue Burst Low Gloss': '#2A52BE',
  'Black Aurora Burst Matte': '#484A49',
  'Blue Wave Black': '#000080',
  'Moss Olive Yellow': '#808000',
  'Pastels Lavender Purple': '#E6E6FA',
  'Pastels Pink': '#FFC0CB',
  'Pastel Sage Green': '#98FB98',
  'Brown Topaz Burst Flat': '#8B4513',
  'Sodalite Flat': '#6A5ACD',
  'Stallion White': '#FFFFFF',
  'Onyx Black': '#000000',
  'Metallic Gray Matte': '#696969',
  'Indigo Aurora Burst Flat': '#483D8B',
  'Antique Violin Burst': '#8B4513',
  'Ember Burst': '#CD5C5C',
  'Telesto Grey': '#708090',
  'Almond Sunburst': '#E0AA9E',
  'Sea Foam Green Matte': '#9FE2BF',
  Mercury: '#E5E5E5',
  'Black Diamond': '#010B13',
  'Turquoise Blue': '#40E0D0',
  'Marble White': '#F3F3F3',
  'Red Reign': '#B22222',
  'Satin Inferno Burst': '#8A3324',
  'Faded Vintage Sunburst': '#CDAE70',
  Violinburst: '#8B3A3A',
  Snowblind: '#F1F1F1',
  'Aged Cherry Sunburst Gloss': '#FF6347',
  'Aged Natural Antique Gloss': '#D2B48C',
  'Miami Blue': '#00BFFF',
  'Chill Grey': '#B0C4DE',
  'Retro Surf Purple': '#663399',
  'Deep Red': '#8B0000',
  'Aged Vintage Sunburst Gloss': '#CD853F',
  'Antique Fade Burst': '#8B4513',
  'TV Yellow': '#E1C16E',
  'Digital Only Curious': '#8B4513',
  'Red White And Blue': '#FF0000',
  'Heritage Tobacco burst': '#8B4513',
  'Blue Chameleon': '#3B3C36',
  'Transparent Black Sunburst High Gloss': '#2F4F4F',
  'Amber Sunburst High Gloss': '#FFBF00',
  'Purple Daze': '#800080',
  'White Elephant Grain': '#FFFFFF',
  'Light Amber': '#FFBF00',
  'Satin Rose Gold': '#B76E79',
  'Dual Shadow Burst Flat': '#2F4F4F',
  'Blue Iceberg Gradation': '#ADD8E6',
  'Black with Silver': '#000000',
  'Tangerine Lacquer Burst': '#FF4500',
  'Blue Lacquer Burst': '#4682B4',
  'Coffee Fade': '#6F4E37',
  'Gloss Natural Blonde': '#D2B48C',
  'Rosegold White': '#B76E79',
  'Bold Blue': '#0000FF',
  'Black-Red': '#8B0000',
  'Black-Yellow': '#FFD700',
  'Tomato Red Matte': '#FF6347',
  'Soft Pink Matte': '#FFB6C1',
  'Cherry Blossom': '#FFC1CC',
  'Black-Grey': '#696969',
  'Mysterious Blue': '#1E90FF',
  Cork: '#D2B48C',
  'Tobacco Sunburst Satin': '#8B4513',
  'Imperial White': '#FFFFF0',
  'Dorado Green': '#4F7942',
  'Eminence Purple': '#8A2BE2',
  'Brushed Aluminum': '#A9A9A9',
  'Aged Dark Burst': '#8B4513',
  'Aged Dark Cherry Burst': '#8B0000',
  'Firemist Silver': '#C0C0C0',
  'Daphne Blue Satin': '#B0E0E6',
  'Dropped Copper': '#B87333',
  'Pueblo Pink Satin': '#FADADD',
  'Black Aged Glass': '#2F4F4F',
  'Olive Tiger Aged Gloss': '#556B2F',
  'Red Tiger Aged Gloss': '#B22222',
  'Red Wood': '#A52A2A',
  'Raspberry Tea Burst': '#E30B5C',
  Cedrum: '#CD853F',
  'Dark Brown Natural Burst': '#8B4513',
  'Dark Rosewood': '#654321',
  'Brown & Beige Stripes': '#8B4513',
  'Ferrari Red': '#FF2800',
  'See Thru Purple': '#800080',
  'Purple Natural Fade': '#8A2BE2',
  'Royal Tan': '#D2B48C',
  'Vintage Suburst': '#8B4513',
  'Black Shadow Burst': '#2F4F4F',
  'Polaris White': '#F8F8FF',
  'Tan Gray': '#D2B48C',
  'Coral Black': '#2F4F4F',
  'Moab Black Red': '#8B0000',
  'Olive Yellow': '#808000',
  'Coral Orange': '#FF7F50',
  'White Glossy': '#FFFFFF',
  'Yellow Glossy': '#FFD700',
  'Greenish Beige': '#C5CBA4',
  'Green-Black': '#004225',
  'Orange-Black': '#FF4500',
  'Black & Gray': '#A9A9A9',
  'Black & Red': '#8B0000',
  Maroon: '#800000',
  Dark: '#555555',
  Light: '#F5F5DC',
  'Black Stained Burst': '#8B4513',
  Traditional: '#F0E68C',
  Squad: '#006400',
  'Open Pore Burgundy Red': '#800020',
  'Black Camo': '#2F4F4F',
  'Silver Flat': '#C0C0C0',
  Forest: '#228B22',
  'Light Oak': '#E6E6FA',
  'Forest Green': '#228B22',
  'Mega Pink': '#FF69B4',
  'Blue & White': '#ADD8E6',
  'Dark Orange': '#FF8C00',
  Yellowgreen: '#9ACD32',
  'Cool Grey': '#8C92AC',
  Stone: '#9C8A78',
  Seafoam: '#93E9BE',
  Coral: '#FF7F50',
  'Dark Silver': '#4F4F4F',
  'Slate Navy': '#465362',
  Cinnamon: '#D2691E',
  Cyan: '#00FFFF',
  Blanchedalmond: '#FFEBCD',
  'Walnut Brown': '#5C4033',
  'Orange Red': '#FF4500',
  'Dark green': '#006400',
  Checkerboard: '#000000',
  'Satin Seafoam Green': '#8ABAB5',
  'Satin Yellow': '#FFF200',
  'Dark Slate Blue': '#483D8B',
  Olivedrab: '#6B8E23',
  OrangeRed: '#FF4500',
  Darkgreen: '#013220',
  'Black and Gold': '#B6862C',
  'Stone Blue': '#748BAF',
  'Charcol Black': '#36454F',
  'Ecru Gold': '#C2B280',
  'Saga Green': '#5E8C31',
  'Red & Black': '#8B0000',
  'Edge Burst': '#3B2F2F',
  'Trans Gold': '#D4AF37',
  'Satin Pink': '#F4C2C2',
  'Albuquerque Noon': '#FFD700',
  'Birch Green': '#568203',
  'Star Dust Black': '#0C090A',
  'Star Dust Green': '#006400',
  'Dragon Eye Burst Low Gloss': '#8B3A3A',
  'Earth Green': '#4A5D23',
  'Purist Blue': '#3165C6',
  Tungsten: '#333333',
  'Charcoal Black Burst Low Gloss': '#36454F',
  'Black Granite': '#1A1A1A',
  'Rose Gold Satin': '#B76E79',
  'Rose Red': '#FF0000',
  '2-Color Bourbon Burst': '#8B4513',
  'Natural QUILT': '#D3CFC5',
  'Black/Light Grey/Dark Grey': '#A9A9A9',
  'Autumn Red': '#D2691E',
  'Night Grey': '#4B4E53',
  'Bonfire Red': '#B22222',
  'Amber Yellow': '#FFBF00',
  'Black and White': '#000000',
  'Glacier Blue': '#87CEEB',
  'Twilight Purple': '#8A2BE2',
  Cognac: '#834333',
  Golden: '#FFD700',
  'Satin Black Top': '#555555',
  Single: '#FFFFFF',
  Pair: '#FFFFFF',
  'Red to Black Fade Lacquer': '#8B0000',
  'Satin Seafoam': '#9FE2BF',
  'Pearlescent White Lacquer': '#F5F5F5',
  'Satin Olive': '#556B2F',
  'Twisted Ivory Finish Ply': '#F2E8DC',
  'Satin Pewter': '#96A8A0',
  'Twisted Ivory': '#FFFFF0',
  'Transparent Cherry': '#DC143C',
  'Iridescent Black Sparkle': '#1C1C1C',
  'Ruby Red Sparkle': '#9B111E',
  'Tri-Color Sunburst': '#E2725B',
  'Opal Spark': '#98FF98',
  'Aged Candy Apple Red': '#A52A2A',
  'Tequila Sunrise': '#FF4500',
  'Chrome and Black': '#B0C4DE',
  'Silver Slate Marine': '#C0C0C0',
  'Sedona Blue': '#4682B4',
  'Brown/Black': '#8B4513',
  'Cosmic Jade': '#00A86B',
  'Belair Blue': '#A7C7E7',
  'Sunset Burst': '#FF7F50',
  Lilac: '#C8A2C8',
  'Dark Gray': '#A9A9A9',
  'Light Beige': '#F5F5DC',
  'Red and Blue Peace Love Dove': '#FF4500',
  'Smoky Beige': '#B8B799',
  'Kashmir Sunset': '#FFA07A',
  'Silver Smoke': '#C0C0C0',
  'Transparent Fluorescent Orange': '#FF5F1F',
  'Satin Shell Pink': '#FFDAB9',
  'Albuquerque Sunset': '#FF4500',
  'Royal Blue Sparkle': '#4169E1',
  'Blue Denim': '#5D8AA8',
  'Grey Denim': '#7F8285',
  'Flamingo Pink': '#FC8EAC',
  'Charcoal Gray': '#36454F',
  'Lilac Purple': '#C8A2C8',
  'Voodoo Fire': '#FF4500',
  'Crimson Maple': '#990000',
  'Natural Fade': '#E3DAC9',
  'Ristra Red': '#C40233',
  'Black Orange': '#FF4500',
  'Golden Red': '#DAA520',
  'Midnight Oil': '#191970',
  'Black and Chrome': '#000000',
  'Black Grey': '#696969',
  'DAD-PWBG10TW': '#000000',
  'Shoreline Gold': '#CBA135',
  'Gunmetal Metallic': '#2A3439',
  'Appetite Burst': '#9A3C1A',
  'November Burst': '#4A2A2A',
  'Vermillion Burst': '#E34234',
  'Anaconda Burst': '#4B5320',
  'Rosewood Burst': '#65000B',
  'Amber Wood Finish': '#FFBF00',
  'Elegant Black': '#000000',
  'Stone White': '#F5F5F5',
  'Beige Gold': '#D8B384',
  'Gold Satin': '#D4AF37',
  'Blue Steel': '#4682B4',
  'Caution Yellow': '#FFD300',
  'Satin Rosewood Burst': '#65000B',
  'Trans Black Fade': '#000000',
  'Blueberry Fade': '#4F86F7',
  'Star Haze': '#C8A2C8',
  'Vintage Ebony': '#C5B358',
  Wallnut: '#7B3F00',
  'Frontier Burst': '#E9967A',
  'Prussian Blue Metallic': '#003153',
  Oil: '#3B3B3B',
  'Wood Finish': '#DEB887',
  'Black Chrome': '#2F4F4F',
  'Autumn Leaf Burst Matte': '#D2691E',
  'Lightning Through A Dark': '#1E1E1E',
  'Blue Wood': '#1E90FF',
  'Sunburst Flat': '#8B4513',
  'Berry Crush': '#8A2BE2',
  'Coral Pink': '#F88379',
  'Orange Sunset': '#FF4500',
  Sunflower: '#FFDA03',
  'Smoke Haze': '#708090',
  'Sand Dune': '#EDC9AF',
  'Sea Green': '#2E8B57',
  'Rainforest Burst': '#2E8B57',
  Voilet: '#8A2BE2',
  'Desert Ripple': '#EDC9AF',
  'Ocean Ripple': '#4682B4',
  'Open Pore Trans Black Burst': '#222222',
  'Vintage Yellow Sunburst': '#FFCC00',
  'Transparent Aqua Blue': '#00CED1',
  'Brown Wood Grain': '#8B4513',
  'White Wood Grain': '#FFFFFF',
  'Orange Sparkle': '#FF4500',
  'Dark Tide Blue Flat': '#1E3F66',
  'Burgundy Metallic Flat': '#800020',
  'Vermillion Red': '#FF2400',
  'Only Piano': '#000000',
  'Piano with Stand': '#000000',
  'Piano with Stand & Bench': '#000000',
  'Matte Silver': '#C0C0C0',
  'Deep Twilight Flat': '#191970',
  'Blue Resin Burl': '#1E90FF',
  'Shell Pink Pearl': '#FFB6C1',
  'Alien Green': '#A3C940',
  Crimson: '#DC143C',
  'Surf Pearl': '#B8E0D4',
  'Blue Reef Gradation': '#6A5ACD',
  'Sky Burst Metallic': '#7C8BA8',
  'High Gloss Black': '#000000',
  'Hot Pink Pearl': '#FF69B4',
  'Starlight Blue': '#4682B4',
  'Whiskey Barrel Burst Satin': '#8B4513',
  'Dragon Fruit': '#FF355E',
  'Ever Green': '#006400',
  'Moon White': '#F0E68C',
  'Nylon Blue': '#1E90FF',
  'Storm Gray': '#708090',
  'Overland Gray': '#BEBEBE',
  'Summit Purple': '#8A2BE2',
  'Black Stain': '#1C1C1C',
  'Red Stain': '#8B0000',
  '3-Tone Vintage Sunburst': '#FFA500',
  'Aged Cognac Burst': '#D2691E',
  'Lava Burst': '#B22222',
  'Polar Ice Burst': '#E0FFFF',
  'Golden Orange': '#FFCC33',
  'Mariana Blue Burst': '#1E3F66',
  'Polished Black': '#000000',
  'Light Burst Satin': '#EEDD82',
  'Vivid Burgundy': '#9F1D35',
  'Slate Grey': '#708090',
  'Maple Wood': '#F5DEB3',
  'Bright Blue Burst': '#0000FF',
  'Lavender Phase': '#E6E6FA',
  'Metallic Light Blue Matte': '#ADD8E6',
  'Phantom Blue': '#191970',
  'Blue Reign': '#4169E1',
  'Sunset Blue Burst': '#4682B4',
  'Dark Red Sparkle': '#8B0000',
  'Ice Ash Wrap': '#AFEEEE',
  'Natural Ebony Tiger Wrap': '#A9A9A9',
  'Transparent Charcoal Burst High Gloss': '#36454F',
  'Vintage Violin High Gloss': '#8B4513',
  'Ivy Green Metallic Flat': '#3B5A24',
  'Transparent Red Sunburst High Gloss': '#A52A2A',
  'Myers Blue': '#5A7D9A',
  'Infinity Blue': '#4B6F8E',
  'Viola Burst': '#8B5F65',
  'Neon Red': '#FF1818',
  'Pacific Peach': '#FFD2B0',
  'FSR Black': '#1C1C1C',
  'Autumn Burst Gloss': '#8C3A2E',
  'Platinum Pearl': '#E5E4E2',
  'Shadow Burst': '#4F4F4F',
  'Brushed Black': '#3D3D3D',
  'Faded Blue Burst': '#6A8DA8',
  Edgeburst: '#3C3C3C',
  'Edgeburst Natural Gloss': '#A67B5B',
  'Woodland Camo': '#4B5320',
  'Emerald Green Low Gloss': '#50C878',
  'Black Top': '#000000',
  'Steel Blue Metallic': '#4682B4',
  'Black Galaxy Sparkle': '#3A3B3C',
  'Aqua Blue Sparkle': '#00FFFF',
  'Crimson Red Sparkle': '#DC143C',
  'Satin Wide 2-Color Sunburst': '#C48E6E',
  'Satin Sea Foam Green': '#9FE2BF',
  'Satin Sonic Blue': '#6AABD2',
  'Black Rhino': '#1C1C1C',
  'Tweed Black': '#333333',
  Celeste: '#B2FFFF',
  'Blue Rhino': '#0000FF',
  'Satin Desert Sand': '#EDC9AF',
  'Open Pore Charcoal Gray': '#4A4A4A',
  'Natural Mahogany High Gloss': '#C04000',
  'Red Ash': '#FF0000',
  'Metallic Silver': '#C0C0C0',
  'Metallic Gray': '#808080',
  'Satin Mocha': '#3D2B1F',
  'Satin Dakota Red': '#C8102E',
  'Satin Trans Blue with Black Racing Stripe Decal': '#007FFF',
  'Satin Trans Purple with Black Racing Stripe Decal': '#800080',
  'Aged Mahogany': '#855E42',
  'Matte Blue Frost': '#6D7B8D',
  'Malibu Sunset': '#FF4500',
  'Java Ebony': '#3B2F2F',
  'Spalted Maple Burst': '#D5A06D',
  'Blue Jean Wash': '#5F9EA0',
  'Dark Tigers Eye': '#483C32',
  'Coral Blue': '#AFEEEE',
  'Open Pore Red': '#8B0000',
  'Clear Acrylic': '#E0E0E0',
  Custom: '#000000',
  'Gloss Koa': '#C68642',
  'Spalted Maple': '#A0522D',
  'Viridian Green': '#228B22',
  'Lake Blue': '#ADD8E6',
  'Burl Burst': '#8B4513',
  'Vintage Amber Burst': '#FFBF00',
  'Gloss Natural Ash': '#D2B48C',
  'Faded Black': '#696969',
  'Z Black': '#000000',
  'Rose Gold Chameleon': '#B76E79',
  'Burnt Umber': '#8A3324',
  'Cerulean Paradise': '#2A52BE',
  'Cobra Burst': '#CB410B',
  'Raspberry Sunset': '#E30B5C',
  'Gloss Tobacco Burst': '#8B4513',
  'Natural HG': '#D3D3D3',
  'Black / Red': '#8B0000',
  'Granite Crystal': '#676767',
  'McCarty Tobacco Sunburst': '#8B4513',
  'Flame Top': '#D2691E',
  'Black Gold Sunburst': '#B8860B',
  'Scarlett Sunburst': '#FF2400',
  'Black White': '#000000',
  'Vintage Wine Barrel': '#5E2F2F',
  'Espresso Brown': '#3C2F2F',
  'Makah Burl': '#8B4513',
  'Open Pore Bubinga Natural': '#A0522D',
  'Cyclone Red': '#FF0000',
  'Misty Black': '#4C516D',
  'Ocean Blue Sparkle': '#1E90FF',
  'Cyclone Silver': '#C0C0C0',
  Creamsicle: '#FFA500',
  'Electric Coral': '#FF4040',
  'Blue Floral': '#4682B4',
  'Red Floral': '#FF0000',
  'Black Floral': '#000000',
  'Baltic Birch': '#D6D6D4',
  'Espresso Burst': '#3E2C1C',
  'Tropical Seafloor Burst': '#00CED1',
  'Charcoal Burst Black Stained Flat': '#36454F',
  'Molten Brown Burst': '#8B4513',
  'Matte Black Walnut': '#696969',
  'Blue Gradation': '#1E90FF',
  'Magic Wave Low Gloss': '#4169E1',
  'Transparent Brown Black Burst': '#4B3621',
  'Dual Mocha Burst Flat': '#8B4513',
  'Strap Blaze Gold': '#FFD700',
  'Antique Cherry': '#CD5C5C',
  'Blue Ocean Sparkle': '#1E90FF',
  'Black Midnight Sparkle': '#000000',
  'Black/Yellow/Brown': '#B89B72',
  'Loud Red': '#FF0000',
  'Transparent Stain Black': '#2B2B2B',
  Khaki: '#C3B091',
  Ocher: '#CC7722',
  'Black Denim': '#2B2B2B',
  'Cobalt Blue Burst': '#0047AB',
  'Black Stained Burst Low Gloss': '#2B2B2B',
  'Burnt Red Mist': '#8A3324',
  'Black out Black': '#000000',
  'Natural with Black Gold Burst': '#FFD700',
  'Red Moon Sparkle': '#FF4500',
  Chromatic: '#FFFFFF',
  'Open Pore Vintage Natural': '#D3C8A1',
  'Natural with Black Gold': '#FFD700',
  'Semi-Gloss': '#C0C0C0',
  'Etched Natural Black': '#2B2B2B',
  'Coffee Tea Wrap': '#6F4E37',
  'Purple Safe': '#800080',
  'Blue Safe': '#0000FF',
  'Red Orange': '#FF4500',
  'Orange Safe': '#FF7F00',
  'Green Safe': '#00FF00',
  'Gray Safe': '#BEBEBE',
  'Limited Edition': '#FFD700',
  'High Gloss Solid Mahogany': '#8B4513',
  Sodalite: '#0F52BA',
  'High Gloss Mahogany': '#C04000',
  'Satin Vintage Blonde': '#F8DE7E',
  'Blood Orange Sparkle': '#FF5349',
  'Diamond Sparkle': '#C0C0C0',
  'Sunflower Sparkle': '#FFD700',
  'Twilight Sparkle': '#8A2BE2',
  'Soft Blue/White': '#B0E0E6',
  'Teal/White': '#008080',
  'Pearl Blue': '#1C39BB',
  'Nylon Cream': '#F5F5DC',
  Raspberry: '#E30B5D',
  'Antique Yellow Sunburst': '#FFD700',
  '3 color Chocolate Burst': '#4B2E1C',
  'Teal Blue Fade': '#008080',
  'Aqua Fade': '#00FFFF',
  'Jumper Red': '#A52A2A',
  'Mejestic Purple': '#800080',
  'FSR Lime Green': '#32CD32',
  'FSR Graffiti Yellow': '#FFD700',
  'Antique Brown Stained': '#8B4513',
  'Translucent Black Satin': '#2F4F4F',
  'Cerulean Aura Burst Matte': '#007BA7',
  'Midnight Arctic Ocean Matte': '#191970',
  'Deep Dusk Burst Flat': '#483D8B',
  'Tropical Seafloor': '#00CED1',
  'Deep Twilight': '#191970',
  Chalk: '#F5F5F5',
  'Aqua Grey': '#708090',
  'Transparent Red Matte': '#FF0000',
  'Blue Chameleon Metallic Matte': '#8A2BE2',
  'Black Night Sparkle': '#000000',
  'Cosmic Silver Sparkle': '#C0C0C0',
  'Lime Green Sparkle': '#32CD32',
  'Sea Blue Mist': '#4682B4',
  'Candy Red Sparkle': '#FF4500',
  'Bahama Blue': '#1E90FF',
  'Olive Dark Green': '#556B2F',
  'Ocean Blue Grey': '#708090',
  Ultraviolet: '#8A2BE2',
  'Crimson Fade': '#DC143C',
  'Trans Chameleon Purple': '#800080',
  'Polar Lights Flat': '#E5E4E2',
  'High Gloss Natural': '#E5E4E2',
  'Mild Green': '#98FB98',
  'Limited Edition Satin Dakota Red': '#E9967A',
  'Antique Turquoise': '#40E0D0',
  'Lilac Purple Fade': '#C8A2C8',
  'Pacific Blue Fade': '#1E90FF',
  'Sanoran Amber Fade': '#FFA07A',
  'Tango Red Fade': '#FF6347',
  'Spectrum Red': '#FF0000',
  'Spectrum Blue': '#0000FF',
  'Black Flake': '#1C1C1C',
  Oxblood: '#4B2E2E',
  'Wild Lvy': '#1E2F23',
  'Dark Vintage Sunburst': '#4A3C31',
  Antique: '#FAEBD7',
  'Coffee Burst': '#6F4E37',
  'Mahogany Oil Burst': '#3E342B',
  'Dual Mocha Burst Fla': '#3F2F2F',
  'Illuminating Yellow': '#F4D03F',
  'Ultimate Gray': '#A9A9A9',
  'Black Flack': '#0A0A0A',
  'Tahitian Coral': '#FF6F61',
  'FSR California Blue': '#5B92E5',
  'Leopard Burl': '#8B4513',
  'Amber Flame': '#FFBF00',
  'Dark Mocha Burst': '#3F2823',
  'Off White Blonde': '#F8F8FF',
  'Koa Natural Burst': '#8B4513',
  'Iri Blue': '#3A4E7F',
  'Black with Black': '#000000',
  'White with Black': '#FFFFFF',
  'Mint Blue': '#AAF0D1',
  Sage: '#9CAF88',
  'Trans Purple Burst': '#9B30FF',
  'Azuki Metallic': '#6D002B',
  Spruce: '#E0D5C0',
  'Dog Hair Smokeburst': '#696969',
  'Faded Cherry Burst': '#D2691E',
  'Blue Matteo': '#4B0082',
  'Vintage Sunburst Gloss': '#C04000',
  'Deep Ocean Blue': '#006994',
  'Modena Red': '#D70040',
  'Open-Pore Sunburst': '#FF4500',
  'Aged Sherwood Green Metallic': '#2C5D50',
  'Glow in Dark': '#A3C1AD',
  'Forest Blue': '#228B22',
  'Tropical Mahogany': '#FFE4B5',
  'Arctic Jade': '#AFEEEE',
  'Blue Snowflake': '#B0E0E6',
  'Red Snowflake': '#FF0000',
  'Yellow Wallflower': '#FFD700',
  'Black Ice Frozen Matte': '#1C1C1C',
  'Cosmic Blue Frozen Matte': '#4B7A97',
  'Wine Red Frozen Matte': '#722F37',
  'Pleasant Pheasant': '#8B4513',
  'Western Rose': '#FF6961',
  'Lavender Blossom': '#E6E6FA',
  'Cinnamon Needlepoint': '#D2691E',
  'White Savannah': '#F5F5F5',
  'Red King': '#FF2400',
  'Vanilla Rose': '#F3E5AB',
  'Tangerine Rose': '#FFCC99',
  'Lavender Rose': '#E6E6FA',
  'White Blossom': '#FFFFFF',
  'Tangerine Blossom': '#FFA07A',
  'Black Pleasant Pheasant': '#5B5B5B',
  'Green Stain': '#228B22',
  'Arctic Ocean Metallic': '#E0FFFF',
  'Cosmic Blue Starburst': '#4682B4',
  'Tokyo Midnight': '#191970',
  Flag: '#FF0000',
  Rock: '#000000',
  Skull: '#000000',
  'Ebony High Polished': '#555D50',
  'Sea Shore Matte': '#4682B4',
  'Brilliance of Now': '#FFD700',
  'Weathered Black Low Gloss': '#4B4B4B',
  'Harmonious Mustard': '#FFDB58',
  'Aqua Marine': '#7FFFD4',
  'Misty Rose': '#FFE4E1',
  'Graffiti Yellow': '#FFD700',
  'Cardinal Red Satin': '#C41E3A',
  'Gold Mist Satin': '#D4AF37',
  'Inverness Green Satin': '#004953',
  'TV Wheat': '#F5DEB3',
  'Ocean Turquoise Metallic': '#48D1CC',
  'Transparent Black Flat': '#2F4F4F',
  'Blue Powder': '#B0E0E6',
  'Ebony Mirror': '#555D50',
  'Polish Ebony': '#555D50',
  'Cardinal Red': '#C41E3A',
  'Amethyst Purple': '#9966CC',
  'Chocolate 2-Color Sunburst': '#8B4513',
  'Silver Metalic': '#C0C0C0',
  'Pink Dusk': '#FFC0CB',
  'Silver Mountain': '#C0C0C0',
  'Luna White': '#E3E3E3',
  Satin: '#C0C0C0',
  'Tremolo Black': '#1C1C1C',
  Gloss: '#C0C0C0',
  'Mandarin Orange Flat': '#FF6700',
  'Aqua Mist': '#7FFFD4',
  'Coral Red Burst': '#FF4040',
  'Sapphire Blue Burst': '#0F52BA',
  'Stained Satin Mahogany': '#8B4513',
  'Butter Cream': '#F3E5AB',
  'High-Gloss': '#C0C0C0',
  'Scarlet Fade': '#FF2400',
  'Black Oak': '#3B3B3B',
  'Transparent Marine Sunburst': '#3B9C9C',
  'Transparent Yellow Sunburst': '#FFD700',
  'Hyla Green Metallic': '#1E7F5C',
  'Shoreline Mist': '#C0C6C9',
  'Canyon Dusk': '#A67C5B',
  'Rex Burst': '#8B4513',
  'Frontier Stain': '#8B5A2B',
  'Transparent Midnight Black': '#000033',
  'Dark Black': '#000000',
  'Indigo Blue': '#4B0082',
  'Infra Red': '#FF4040',
  'Astro Dust': '#805A46',
  'White Sage': '#E5E5E5',
  'Silver Blizzard Matte': '#D9D9D9',
  'Black Oak-ish': '#3B2F2F',
  'Natural Browned Burst Flat': '#8B4513',
  'Copper Sparkle': '#B87333',
  'Platinum Sparkle': '#E5E4E2',
  'Black /White': '#000000',
  'Black and Red': '#8B0000',
  'Carbon Gray': '#36454F',
  'Fire Burst': '#B22222',
  'Forge Glow': '#FF4500',
  'Bone White': '#F8F8FF',
  'Wavy Checkerboard': '#FFFFFF',
  'Antique Silverburst': '#C0C0C0',
  'Abbey Ale': '#8B7500',
  'Steel Olive': '#708090',
  'Appetite Amber': '#FFBF00',
  'Pastel Green': '#77DD77',
  'White Sand': '#F5F5DC',
  'Natural with Gold': '#DAA520',
  Brandywine: '#B22222',
  'Wine Red Satin': '#722F37',
  'Dark Wine Red': '#8B0000',
  'Sandblasted Red': '#8B0000',
  'Sandblasted Blue': '#000080',
  'Sandblasted Green': '#008000',
  'Sandblasted Purple': '#800080',
  'Sandblasted White': '#FFFFFF',
  'Black Forest': '#0B3D91',
  'Dark Red Wine': '#8B0000',
  'BlackGalaxy Sparkle': '#1B1B1B',
  'Real Wood': '#8B5A2B',
  'Translucent Charcoal': '#36454F',
  'Translucent Natural': '#D2B48C',
  'Gloss Charcoal Burst': '#2F4F4F',
  'Midnight Black Satin': '#191919',
  Amethyst: '#9966CC',
  'Coral Red': '#FF4040',
  'Placid Blue': '#A7C7E7',
  'Vintage Yellow': '#FFE135',
  'Purple and Blue Gradient': '#663399',
  'Nebula Noir': '#0C090A',
  'Dawn Sunburst': '#FDD017',
  'Fire Red': '#B22222',
  'Lagoon Turquoise': '#48D1CC',
  'Comet Burst': '#FF4500',
  'Coffee Fad': '#6F4E37',
  'Purple Fad': '#4B0082',
  'Wine Burst Matte finish': '#7B3F00',
  'Wine Fade': '#722F37',
  'Purple Fade': '#7D3F98',
  'Hialeah Yellow': '#F3C300',
  'Burnt Orchid': '#7E3946',
  'Lambo Green Metallic': '#A5C91E',
  'Natural Mahogany': '#C04000',
  'Aquatone Blue': '#7EC8E3',
  'Liquid Amber': '#D1913C',
  'Transparent Cherry Burst': '#990000',
  'Transparent Mocha Burst': '#3D2817',
  'Sea Foam': '#93E9BE',
  'Cerulean Paradise Flame': '#007BA7',
  'Purple Nebula Flame Top': '#5E2D79',
  'American White Ash': '#E8E8E8',
  'Sahara Burst Quilt': '#C19A6B',
  'Open Pore Olive Green': '#708238',
  'Open Pore White': '#F5F5F5',
  Barnwood: '#8B7363',
  'Day of the Dead': '#FF5733',
  Simbra: '#8A2BE2',
  'Red with Black and White Stripes': '#FF0000',
  'Hojicha Burst': '#8B645A',
  'Twilight Blue Burst': '#1C3A77',
  'See-Thru Blue Burst': '#4682B4',
  'Lumberjack Frontplate': '#A0522D',
  'White Moto': '#FFFFFF',
  'Green Moto': '#00FF00',
  'Purple Moto': '#800080',
  'Dark Cherry Metallic': '#8B0000',
  'White Gold': '#D4AF37',
  Mako: '#000000',
  'Black/Orange': '#FF4500',
  'Exotic Aegean Fade': '#5F9EA0',
  Cafe: '#6F4E37',
  Morado: '#8B4513',
  'Arctic Blue Flat': '#E0FFFF',
  'Two-Tone Vintage White/London Grey': '#F5F5DC',
  'Barrel Burst': '#8B4513',
  Vintage: '#F5DEB3',
  Titanium: '#B0C4DE',
  'Penumbra Blue': '#00008B',
  'Sapphire Fade Lacebark Pine': '#0C2D6B',
  'Sunset Fade Lacebark Pine': '#FF4500',
  'Gloss Brown Sunburst': '#8B4513',
  'Gloss Black with Silver Pinstripes': '#000000',
  'White Blonde Gloss': '#F5F5DC',
  'Surf Green Metallic': '#40E0D0',
  'Sparkle Black': '#000000',
  'Classic Satin AmBurst': '#8B3A3A',
  'Mystic Sea Foam Green': '#7FFFD4',
  'Moc Sand Satin': '#F5DEB3',
  'Wine Burgundy': '#800020',
  'Transparent Black Satin': '#2F4F4F',
  'Green Ice Fade': '#00FF7F',
  'Natural To Black Fade': '#3C3C3C',
  'Ninja Black with Central Groove': '#1C1C1C',
  'Retro Yellow': '#FFFF00',
  'Default Title': '#FFFFFF',
  'Flare Orange': '#FF4500',
  'Natural Bocote': '#8B4513',
  'Natural Spalted Maple': '#8B4513',
  'Open Pore Vintage Burst': '#C47F4E',
  'Mystic Blue': '#3B83BD',
  'Oak Green Metallic': '#556B2F',
  'Transparent Turquoise Burst': '#00CED1',
  'Caribbean Green Low Gloss': '#00FF7F',
  'Cosmic Blue Low Gloss': '#6495ED',
  'Noble Blue': '#000080',
  'Solar Flare': '#FF4500',
  'Sinister Red': '#B22222',
  Avalanche: '#E1F8E7',
  'Red Eclipse Burst': '#DC143C',
  'Brown Sunburst Flat': '#8B4513',
  'Brooklyn Burst': '#8B4513',
  'Aged Honey Burst': '#FFA07A',
  'Rootbeer Fade': '#8B4513',
  'Putty Grey': '#BEBEBE',
  'Natural Maple': '#D3D3D3',
  'Antique Walnut': '#8B4513',
  'Factory Burst': '#8B0000',
  'Deep Sea': '#4682B4',
  Lab: '#E5E4E2',
  'Indigo Burst': '#4B0082',
  'Blue Haze': '#6897BB',
  'Vintage Mahogany Sunburst High Gloss': '#C04000',
  'Striped Blue': '#1E90FF',
  'Striped Red': '#FF4500',
  'Striped Grey': '#708090',
  'Deep Ocean Blonde': '#B0E0E6',
  'Whiskey Burst Satin': '#D2691E',
  'Nicotine Marine Inlay': '#4682B4',
  'Cosmic Blue Starburst Low Gloss': '#191970',
  'Black Out': '#000000',
  'Trans White': '#F5F5F5',
  'Victorian Burst': '#8B4513',
  'Silver Wave Black Low Gloss': '#2F4F4F',
  'Gloss Exotic Maple': '#B8860B',
  'Graphite Silver Twist': '#778899',
  'Caramel Aurora': '#FFA07A',
  'Dark Cherry Fade': '#8B0000',
  'Molten Steel Blue Burst': '#4682B4',
  'Sky Blue Aurora': '#87CEEB',
  Wooden: '#C19A6B',
  'Graphite Green Metallic': '#4A6F44',
  'McCarty Tobacco Burst': '#8B4513',
  Colorful: '#FF00FF',
  'Red with Black Stripes': '#8B0000',
  'Steel Gray': '#A9A9A9',
  'Gun Metal Grey': '#2C3539',
  'Military Green Satin': '#4B5320',
  'Natural Semi Gloss': '#D3D3D3',
  'See Thru Black  Cherry Sunburst': '#8B0000',
  'Orange Tiger Smokeburst': '#FF4500',
  'Blue Slate Satin': '#6A5ACD',
  'Fire Blast': '#FF4500',
  'Sage Green': '#9C9F84',
  'Aurora Pink': '#FF69B4',
  'Aurora Green': '#32CD32',
  'Aurora Purple': '#800080',
  'Woodland Camo Satin': '#556B2F',
  'Charcoal Metallic Satin': '#36454F',
  'Vintage Black': '#1A1A1A',
  Antigua: '#E0D6BF',
  'Dark Indigo': '#2D2D72',
  'Pearl Black': '#0A0A0A',
  'Chrome Glow': '#CCCCCC',
  'Crimson Royal Bloom': '#990033',
  'Black Open Grain Satin': '#1A1A1A',
  'Open Pore Amber': '#D3A15D',
  'Black Checkers': '#1A1A1A',
  'Open Pore Brown': '#8B5A2B',
  'Vintage Violin': '#8B4513',
  'Black/Green': '#1A1A1A',
  'Black Onyx Sparkle Finish Ply': '#1A1A1A',
  'Pale Rose Sparkle Finish Ply': '#E8D3D3',
  'Candy Cola': '#9C0000',
  Bronze: '#CD7F32',
  'See Thru Purple Sunburst': '#6A0DAD',
  'Cherry Stain Gloss Lacquer': '#800000',
  'Steel Gray Gloss Lacquer': '#708090',
  'Tobacco Burst Gloss Lacquer': '#8B4513',
  'Charcoal Cherry Midnight Burst': '#36454F',
  'Matte Red': '#C41E3A',
  'Matte Asphalt Black': '#3E3E3E',
  'Open Pore Blue': '#4682B4',
  'Satin Olive Finish Ply': '#556B2F',
  'Satin Seafoam Finish Ply': '#9FE2BF',
  'Satin Black Finish Ply': '#2C2C2C',
  'Aqua Marine Metallic': '#78DBE2',
  'Pink Leopard': '#FC74FD',
  'Charcoal Burst Satin': '#36454F',
  'Antique Gold': '#D4AF37',
  'Purple and Silver': '#800080',
  'Emerald Argyle': '#50C878',
  'Purple Python': '#800080',
  'Red and Silver': '#FF0000',
  'Black Fade Burst Burl': '#2E2E2E',
  'Charcoal Satin': '#36454F',
  'Tobacco Burl': '#8B4513',
  'Hot Rod Red': '#FF4500',
  'Desert Sun Yellow': '#FFD700',
  'Coyote Brown': '#81613C',
  'Carbon Ripstop': '#3C3C3C',
  'Nebula Mappa Burl Fade': '#8A7FA1',
  'Satin Purple Atmosphere Fade': '#6A5ACD',
  'Jazz Burst': '#B8860B',
  'Molten Electric Blue Burst': '#1E90FF',
  'Marine Shoreline Movingui Fade': '#4682B4',
  'Ocean Blue Burst Burl': '#1E90FF',
  'Gloss burst': '#A9A9A9',
  'Purple Burst Burl': '#800080',
  'Stained Red': '#8B0000',
  'Sonic Grey': '#708090',
  'Bourbone Fade': '#8B4513',
  'FSR Arctic White': '#F8F8FF',
  'Artisan Zebra Wood': '#D2B48C'
}

// let timeCheckedTemplates = 0;
// const checkAndMoveDiv = setInterval(() => {
//   timeCheckedTemplates++;

//   if (moveTemplatesToBody()) {
//     clearInterval(checkAndMoveDiv);
//   }

//   if (timeCheckedTemplates === 10) {
//     clearInterval(checkAndMoveDiv);
//   }
// }, 10);



function syncAutocompleteWidth() {
  const searchBar = document.querySelector('.predictive-mediasearch.input'); // update selector if needed
  const autoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

  if (searchBar && autoComplete) {
    const width = searchBar.offsetWidth + 'px';
    document.documentElement.style.setProperty('--wizzy-autocomplete-width', width);
  }
}
document.body.addEventListener("click", function (event) {
    const target = event.target;
    if (target.matches(".predictive-mediasearch.input")) {
      setTimeout(syncAutocompleteWidth, 100);      
    }
});
window.addEventListener('load', syncAutocompleteWidth);
window.addEventListener('resize', syncAutocompleteWidth);


window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("BEFORE_INIT data : ",data);
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        data.search.configs.pagination.infiniteScrollOffset = {
            desktop: 2000,
            mobile: 1600,
        };
        const customfacets = data?.search?.configs?.facets?.configs;

        if (Array.isArray(customfacets)) {
          const brandIndex = customfacets.findIndex(f => f.key === "brands");

          if (brandIndex !== -1) {
            const brandFacet = customfacets[brandIndex];
            const newOrder = (brandFacet.order ?? 0) + 1;

            customfacets.splice(brandIndex + 1, 0, {
              key: "product_shipping",
              label: "Shipping Time",
              position: "left",
              order: newOrder
            });
          } else {
            // fallback: if brands not found, just push with a default order
            customfacets.push({
              key: "product_shipping",
              label: "Shipping Time",
              position: "left",
              order: 60
            });
          }
        }
        data.search.configs.facets.configs = customfacets;

        try {
            if (window.wizzyConfig?.search?.configs?.facets?.configs) {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.map((obj) => {
            if (obj.key === "sellingPrice") {
              obj.buckets = [
                { from: 0, to: 500 },
                { from: 500, to: 1000 },
                { from: 5000, to: 10000 },
                { from: 10000, to: 15000 },                                                             
                { from: 15000, to: 20000 },
                { from: 20000, to: 30000 },
                { from: 30000, to: 40000 },
                { from: 40000, to: 50000 },
                { from: 50000 },
              ];
            }
            return obj;
          });
      }
        } catch {}
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
      function (data) {
        setTimeout(syncAutocompleteWidth, 2); 
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (data) {
        data.common.lazyDOMConfig.searchInputIdentifiers = [{
          "dom" : ".predictive-mediasearch.input",
          "type" : "search"
        }];
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        data.search.configs.pagination.infiniteScrollOffset = {
            desktop: 2000,
            mobile: 1600,
        };

        const customfacets = data?.search?.configs?.facets?.configs;

        if (Array.isArray(customfacets)) {
          const brandIndex = customfacets.findIndex(f => f.key === "brands");

          if (brandIndex !== -1) {
            const brandFacet = customfacets[brandIndex];
            const newOrder = (brandFacet.order ?? 0) + 1;

            customfacets.splice(brandIndex + 1, 0, {
              key: "product_shipping",
              label: "Shipping Time",
              position: "left",
              order: newOrder
            });
          } else {
            // fallback: if brands not found, just push with a default order
            customfacets.push({
              key: "product_shipping",
              label: "Shipping Time",
              position: "left",
              order: 60
            });
          }
        }
        data.search.configs.facets.configs = customfacets;
        try {
            if (window.wizzyConfig?.search?.configs?.facets?.configs) {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.map((obj) => {
            if (obj.key === "sellingPrice") {
              obj.buckets = [
                { from: 0, to: 500 },
                { from: 500, to: 1000 },
                { from: 5000, to: 10000 },
                { from: 10000, to: 15000 },
                { from: 15000, to: 20000 },
                { from: 20000, to: 30000 },
                { from: 30000, to: 40000 },
                { from: 40000, to: 50000 },
                { from: 50000 },
              ];
            }
            return obj;
          });
      }
        } catch {}
        return data;
      }
  );

  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
        // console.log("BEFORE_SEARCH_EXECUTED : ",data);
        const bannerSection = document.querySelector(".shopify-section.collection-banner-section");
        if (bannerSection) {
          bannerSection.style.display = "none";
        }
        // data.includeOutOfStock = "false";
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
      function (data) {
        // console.log("AFTER_WIZZY_API_RESPONDED : ",data);
        if (data.api === "autocomplete") {
          data?.response?.payload?.categories?.forEach((category) => {
            if (category.filters.categories[0].includes("_wzAc")) {
              category.payload.forEach((item) => {
                if (item.key === "relatedCategories") {
                  item.value[0].url = undefined;
                }
              })
            }
          })
        }
        return data;
      }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (data) {
        // console.log("BEFORE_RENDER_RESULTS : ",data);
        // data.includeOutOfStock = "false";
        if(data.api === "search" || data.api === "filter") {
          var facets = data?.response?.payload?.facets;
          if(facets){
            facets.forEach((facet) => {
              if(facet.key === "sellingPrice" && facet.type === "range-list") {
                facet.data = facet.data.filter(item => item.count !== 0);
              }
            })
          }
        }
        return data;
      }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      const targetCategories = ["mackie","mackie-mixers","mackie-monitor-speakers","mackie-loudspeakers","acoustic-guitar-strings","banjo-strings","bass-guitar-strings","violin-strings","guitar-picks","picks","classical-guitar-strings","double-bass-strings","electric-guitar-strings","mandolin-strings","sitar-strings","ukulele-strings","viola-strings","cello-strings"];
       products.forEach((product) => {
        product.attributes.forEach((attr) => {
          if (attr.id == "product_badge_judgeme") {
            let divElement = document.createElement("div");
            divElement.innerHTML = attr.values[0].value[0];
            var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
            var jdgmReviewData = jdgmPrevBadge.getAttribute(
              "data-average-rating"
            );
            var numberOfReviews = jdgmPrevBadge.getAttribute(
              "data-number-of-reviews"
            );
            if (numberOfReviews > 0) {
              product.numberOfReviews = numberOfReviews;
              product.jdgmReviewData = parseFloat(jdgmReviewData).toFixed(1);
            }
          } else if (attr.id === "product_label_theme") {
            if(attr.values[0].value[0] !== "") {
              product.productBadge = attr.values[0].value[0];
            }
           } else if(attr.id === "product_variant_title_custom") {
              let hasTargetCategory = product.categories.some(cat => targetCategories.includes(cat.id));
              if (hasTargetCategory) {
                // console.log("Here");
                  product.name = attr.values[0].value[0];
              }
           }
        })
        product.sellingPrice = parseInt(product.sellingPrice.replace(/,/g, "")).toLocaleString("en-IN");
        if(product.price && product.discountPercentage > 0) {
           product.price = parseInt(product.price.replace(/,/g, "")).toLocaleString("en-IN");
         }
         let extraSwatchNum = 0;
        product?.swatches?.forEach((swatch) => {
            if (swatch.key === "product_Color" ) {
              let valLen = swatch.values.length;
              if (valLen > 4) {
                extraSwatchNum = valLen - 4;
                product.extraSwatchNum = extraSwatchNum;
                swatch.values = swatch.values.slice(0, 4);
              }
              swatch.values.forEach((val) => {
                  val.isSwatch = true;
                  val.isVisualSwatch = true;
                  val.swatchValue = colorMap[val.value];
              })
            }
        })    
      })
      return products;
    }
  );
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (data) {
        const sortCloseDiv = document.querySelector(
          ".wizzy-common-select-container .wizzy-common-select-options.sort-close"
        );
        if (sortCloseDiv) {
          sortCloseDiv.style.display = "none";
        }
        // data.filters.attributeFacetValuesLimit = 50;
        // console.log("BEFORE_FILTERS_EXECUTED",data.filters.boostGroupIds);
        if (data.filters.boostGroupIds) {
            delete data.filters.boostGroupIds;          
        }

        if(data.group == "categoryPage") {
          data.filters.inStock = [true];
        }
        // console.log(data.gorup,window.wizzyConfig.common.isOnCategoryListing,window.wizzyConfig.common.collectionHandle);
        if(data.group == "categoryPage" && window.wizzyConfig.common.isOnCategoryListing && (window.wizzyConfig.common.collectionHandle == "mackie" || window.wizzyConfig.common.collectionHandle == "mackie-mixers" || window.wizzyConfig.common.collectionHandle == "mackie-monitor-speakers" || window.wizzyConfig.common.collectionHandle == "mackie-loudspeakers")) {
          // console.log("Hereeeeeee");
          data.filters.getAllVariants = "true";
        }
        // if(window.wizzyConfig.common.isOnCategoryPage) {
        //   data.filters.sort = [{
        //   "field": "product_wizzy-best-selling_sortOrder:float",
        //   "order": "asc"
        // }];
        // }
        return data;
      },3
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      document
        .querySelector(".wizzy-filter-button")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
      let sortClose = document.querySelector(
        ".wizzy-common-select-options.sort-close"
      );
      // console.lo
      if (sortClose) {
        sortClose.addEventListener("click", function () {
          if (window.innerWidth > 768) {
            document
              .querySelectorAll(
                ".wizzy-common-select-options.sort-close, .wizzy-common-select-options.sort-close-border"
              )
              .forEach((el) => {
                el.style.display = "none";
              });
          }
        });
        document
        .querySelector(
          ".wizzy-search-filters-drawer-button .button.button--secondary.icon-with-text.wizzy-filters-desktop-entry"
        )
        .addEventListener("click", () => {
          cursorFeatureActive = !cursorFeatureActive;
        });

      document
        .querySelectorAll(
          ".wizzy-search-filters-left-wrapper, .wizzy-filters-header, .wizzy-filters-close-btn"
        )
        .forEach((el) => {
          el.addEventListener("mouseenter", () => {
            if (cursorFeatureActive) {
              document
                .querySelector(".mouse-cursor")
                .classList.remove("active");
              document.body.style.cursor = "default";
            }
          });

          el.addEventListener("mouseleave", () => {
            if (cursorFeatureActive) {
              document.querySelector(".mouse-cursor").classList.add("active");
              document.body.style.cursor = "none";
            }
          });
        });

      document.addEventListener("mouseout", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.remove("active");
        }
      });

      document.addEventListener("mouseover", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.add("active");
        }
      });

      document
        .querySelectorAll(".wizzy-filters-bg, .wizzy-filters-close-btn")
        .forEach((el) => {
          el.addEventListener("click", () => {
            cursorFeatureActive = false;
            document.querySelector(".mouse-cursor").classList.remove("active");
            document.body.style.cursor = "default";
          });
        });
      if (window.innerWidth < 768) {
        
        var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {
        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
        if (window.innerWidth < 768) {
          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        } else {
          if (targetDiv) {
            var clonedSort = targetDiv.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (clonedSort) {
              clonedSort.remove();
            }
          }
        }
      }

      
        const filterHeaderTitle = document.querySelector(
          ".wizzy-search-filters-left .wizzy-filters-header .header-title"
        );
        if (filterHeaderTitle) {
          // console.log("Condition executed");
          filterHeaderTitle.textContent = "Filter and sort";
        }
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
        );

        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            // event.preventDefault();
            // event.stopPropagation();
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
        var hoverElement = document.querySelector(
          ".wizzy-common-select-container > .wizzy-common-select-selector"
        );

        if (
          hoverElement &&
          !hoverElement.classList.contains("click-listener-attached")
        ) {
          hoverElement.addEventListener("click", function (event) {
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );

            if (sortOptions.length > 1) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });

          hoverElement.classList.add("click-listener-attached");
        }
      }
      if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle == "lightning-deals-bajaao" || window.wizzyConfig.common.collectionHandle == "open-box-gear" ||  window.wizzyConfig.common.collectionHandle == "sale")) {
      const searchList = document.querySelector(".wizzy-search-wrapper .wizzy-search-results-container .wizzy-search-results .wizzy-search-results-list");
      const productTypeGridFilter = document.querySelector(".wizzy-grid-filters-box.facet-block-product_product_type");
      const firstProduct = searchList.querySelector(".wizzy-search-wrapper .wizzy-search-results-container .wizzy-search-results .wizzy-search-results-list .wizzy-result-product");
    
      if (searchList && productTypeGridFilter && firstProduct && !productTypeGridFilter.classList.contains("moved-once")) {
        searchList.insertBefore(productTypeGridFilter, firstProduct);
        productTypeGridFilter.classList.add("moved-once");
      }
    }
        gridFiltersToggleOnOverflow();
      return data;
    }
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      document
        .querySelector(".wizzy-filter-button")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
      let sortClose = document.querySelector(
        ".wizzy-common-select-options.sort-close"
      );
      // console.lo
      if (sortClose) {
        sortClose.addEventListener("click", function () {
          if (window.innerWidth > 768) {
            document
              .querySelectorAll(
                ".wizzy-common-select-options.sort-close, .wizzy-common-select-options.sort-close-border"
              )
              .forEach((el) => {
                el.style.display = "none";
              });
          }
        });
        document
        .querySelector(
          ".wizzy-search-filters-drawer-button .button.button--secondary.icon-with-text.wizzy-filters-desktop-entry"
        )
        .addEventListener("click", () => {
          cursorFeatureActive = !cursorFeatureActive;
        });

      document
        .querySelectorAll(
          ".wizzy-search-filters-left-wrapper, .wizzy-filters-header, .wizzy-filters-close-btn"
        )
        .forEach((el) => {
          el.addEventListener("mouseenter", () => {
            if (cursorFeatureActive) {
              document
                .querySelector(".mouse-cursor")
                .classList.remove("active");
              document.body.style.cursor = "default";
            }
          });

          el.addEventListener("mouseleave", () => {
            if (cursorFeatureActive) {
              document.querySelector(".mouse-cursor").classList.add("active");
              document.body.style.cursor = "none";
            }
          });
        });

      document.addEventListener("mouseout", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.remove("active");
        }
      });

      document.addEventListener("mouseover", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.add("active");
        }
      });

      document
        .querySelectorAll(".wizzy-filters-bg, .wizzy-filters-close-btn")
        .forEach((el) => {
          el.addEventListener("click", () => {
            cursorFeatureActive = false;
            document.querySelector(".mouse-cursor").classList.remove("active");
            document.body.style.cursor = "default";
          });
        });
      if (window.innerWidth < 768) {
        
        var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {
        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
        if (window.innerWidth < 768) {
          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        } else {
          if (targetDiv) {
            var clonedSort = targetDiv.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (clonedSort) {
              clonedSort.remove();
            }
          }
        }
      }

      
        const filterHeaderTitle = document.querySelector(
          ".wizzy-search-filters-left .wizzy-filters-header .header-title"
        );
        if (filterHeaderTitle) {
          // console.log("Condition executed");
          filterHeaderTitle.textContent = "Filter and sort";
        }
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
        );

        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            // event.preventDefault();
            // event.stopPropagation();
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
        var hoverElement = document.querySelector(
          ".wizzy-common-select-container > .wizzy-common-select-selector"
        );

        if (
          hoverElement &&
          !hoverElement.classList.contains("click-listener-attached")
        ) {
          hoverElement.addEventListener("click", function (event) {
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );

            if (sortOptions.length > 1) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });

          hoverElement.classList.add("click-listener-attached");
        }
      }
      if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle == "lightning-deals-bajaao" || window.wizzyConfig.common.collectionHandle == "open-box-gear" ||  window.wizzyConfig.common.collectionHandle == "sale")) {
      const searchList = document.querySelector(".wizzy-search-wrapper .wizzy-search-results-container .wizzy-search-results .wizzy-search-results-list");
      const productTypeGridFilter = document.querySelector(".wizzy-grid-filters-box.facet-block-product_product_type");
      const firstProduct = searchList.querySelector(".wizzy-search-wrapper .wizzy-search-results-container .wizzy-search-results .wizzy-search-results-list .wizzy-result-product");
    
      if (searchList && productTypeGridFilter && firstProduct && !productTypeGridFilter.classList.contains("moved-once")) {
        searchList.insertBefore(productTypeGridFilter, firstProduct);
        productTypeGridFilter.classList.add("moved-once");
      }
    }
        gridFiltersToggleOnOverflow();
      return data;
    }
    });
}

function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");
    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");
        
        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          // console.log("lineHeight",lineHeight)
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;
          // console.log("visibleLines",visibleLines)
          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}

const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
  }
}

const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const observer = new MutationObserver(callback);
if (targetNode) {
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
}